import Autocomplete from '@mui/material/Autocomplete'; 
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import InfoIcon from '@mui/icons-material/Info';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import ImageIcon from '@mui/icons-material/Image';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import Collapse from '@mui/material/Collapse';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import Checkbox from '@mui/material/Checkbox';
import AcoesANP from './ANP/components/ACOES_ANP';
import AcoesPosProducaoResumo from './ANP/components/AcoesPosProducaoResumo';






import { API_URL } from './api';  // Verifique se está apontando para o arquivo correto
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import React, { useState, useEffect } from 'react';
import Login from './Login';
import FormularioGPD from './GPD/components/FormularioGPD';
import TabelaGPD from './GPD/components/TabelaGPD';
import AppANP from './ANP/AppANP';
import PreOrcamentoApp from './PreOrcamento/PreOrcamentoApp';






import {
  Container, Typography, TextField, Button, Select, MenuItem, FormControl,
  InputLabel, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Dialog, DialogTitle, DialogContent, DialogActions, Grid, IconButton, Popover, Box
} from '@mui/material';

import axios from 'axios';
import jsPDF from 'jspdf';
import 'jspdf-autotable';

import logoImpram from './Imagens/logo-impram.png';



// CSS para piscar a linha do processo atual
const stylePisca = document.createElement('style');
stylePisca.innerHTML = `
@keyframes pisca {
  0% { opacity: 1; }
  50% { opacity: 0.4; }
  100% { opacity: 1; }
}`;
document.head.appendChild(stylePisca);

const nomesProcessos = [
  "DESENVOLVIMENTO P&D", 
  "PRÉ-IMPRESSÃO", "REFILE INICIAL", "IMPRESSÃO", "LAMINAÇÃO",
  "SERIGRAFIA", "EMPASTADEIRA", "ONDULADEIRA", "ACOPLADEIRA",
  "CORTE VINCO", "DESTAQUES", "HOT STAMPING", "FECHADORAS",
  "FRESA", "CAIXA RIGIDA", "BANCADA CAIXA RIGIDA",
  "BANCADA REVISÃO", "INSPEÇÃO NOVOS PROJETOS", "INSPEÇÃO DA QUALIDADE"
];


function formatarDataBR(data) {
  if (!data) return '';
  const d = new Date(data);
  if (isNaN(d.getTime())) return '';
  return d.toLocaleDateString('pt-BR', { timeZone: 'UTC' });
}

function criarProcessosSelecionados(selecionados, insumosMap) {
  return selecionados.map(nome => ({
    nome,
    status: "",
    dataPlanejada: "",
    dataChegadaInsumo: "",
    dataRenegociada: "",
    dataConclusao: "",
    insumo: insumosMap && insumosMap[nome] ? insumosMap[nome] : "",
    disponibilidade: ""
  }));
}

function getBase64Logo(imgPath) {
  return new Promise((resolve) => {
    const img = new window.Image();
    img.crossOrigin = "anonymous";
    img.src = imgPath;
    img.onload = function () {
      const canvas = document.createElement('canvas');
      canvas.width = img.width; canvas.height = img.height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);
      resolve(canvas.toDataURL('image/png'));
    };
    img.onerror = () => resolve(null);
  });
}

function reorder(list, startIndex, endIndex) {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
}

function App() {

  
  const [usuarioAtual, setUsuarioAtual] = useState(null);
  const [mostrarCadastro, setMostrarCadastro] = useState(false);
  const [filtroTipo, setFiltroTipo] = useState('');



  async function handleCadastroUsuario() {
  try {
    await axios.post(`${API_URL}/usuarios`, novoUsuario);
    alert('Usuário cadastrado com sucesso!');
    setMostrarCadastro(false);
  } catch (error) {
    console.error("Erro ao cadastrar usuário:", error);
    alert('Erro ao cadastrar usuário.');
  }
}


  //COMEÇO DO APP


const [dicaCodigoCV, setDicaCodigoCV] = useState('');
const [dicaCodigoIM, setDicaCodigoIM] = useState('');


const [modoApp, setModoApp] = useState(() => {

  
  const salvo = localStorage.getItem('modoApp');
  
  return salvo || 'principal';
});


const [dadosModo, setDadosModo] = useState(null);

const [modo, setModo] = useState(() => {
  const saved = localStorage.getItem('usuario');
  try {
    const parsed = saved ? JSON.parse(saved) : null;
    const tipos = Array.isArray(parsed?.tipo)
      ? parsed.tipo.filter(t => typeof t === 'string').map(t => t.toLowerCase())
      : typeof parsed?.tipo === 'string'
      ? [parsed.tipo.toLowerCase()]
      : [];

    return tipos.includes('projetos') ? 'projetos' : 'gpd';
  } catch (e) {
    console.error("Erro ao parsear tipo de usuário:", e);
    return 'gpd';
  }
});






  

  const [itensGPD, setItensGPD] = useState([]);

// --- AUTENTICAÇÃO ---
const [usuario, setUsuario] = useState(() => {
  const saved = localStorage.getItem('usuario');
  if (saved) {
    const parsed = JSON.parse(saved);

        // Normaliza tipo: se for array, pega o primeiro tipo como string
    parsed.tipo = Array.isArray(parsed.tipo)
      ? parsed.tipo[0]
      : parsed.tipo;


    // Reforça o campo login se estiver ausente
    if (!parsed.login && localStorage.getItem('auth-token')) {
      parsed.login = localStorage.getItem('usuarioLogin') || '';
    }
    return parsed;
  }
  return null;
});

useEffect(() => {
  
}, [usuario]);

const tiposDoUsuario = React.useMemo(() => {
  if (!usuario) return [];
  if (Array.isArray(usuario.tipo)) {
    return usuario.tipo
      .filter(t => typeof t === 'string')
      .map(t => t.toLowerCase());
  }
  if (typeof usuario.tipo === 'string') {
    return [usuario.tipo.toLowerCase()];
  }
  return [];
}, [usuario]);




const [novoUsuario, setNovoUsuario] = useState({
  nome: '',
  login: '',
  senha: '',
  tipo: ''
});





  const [uploading, setUploading] = useState(false);
  const [arquivosAnexados, setArquivosAnexados] = useState({
    desenhoTecnico: '',
    desenhoIndividual: '',
    anexo1: '',
    anexo2: '',
    anexo3: ''
  });
 

  const [grupoAnexosIdx, setGrupoAnexosIdx] = useState(null);
  const [processoEdicao, setProcessoEdicao] = useState({ grupoIdx: null, procIdx: null, nome: '' });
  const [projetos, setProjetos] = useState([]);
  const [abrirCadastro, setAbrirCadastro] = useState(false);
  const [insumosMap, setInsumosMap] = useState({});
  const [selectedProjeto, setSelectedProjeto] = useState(null);
  const [gruposEdicao, setGruposEdicao] = useState([]);
  const [editandoProjeto, setEditandoProjeto] = useState(null);
  const [novoGrupoNomeEdicao, setNovoGrupoNomeEdicao] = useState('');
  const [processosSelecionadosEdicao, setProcessosSelecionadosEdicao] = useState([]);
  const [anchorCodigos, setAnchorCodigos] = useState(null);
  const [codigosParaMostrar, setCodigosParaMostrar] = useState([]);
  const [filtroIM, setFiltroIM] = useState('');
  const [filtroCliente, setFiltroCliente] = useState('');
  const [clientes, setClientes] = useState([]); // <-- NÃO usa mais localStorage!
  const [usuariosCadastrados, setUsuariosCadastrados] = useState([]);
  const [abrirModalCliente, setAbrirModalCliente] = useState(false);
  const [novoCliente, setNovoCliente] = useState('');
  const novoProjetoInicial = {
    op: '',
    cliente: '',
    nomeProjeto: '',
    codigoIM: '',
    codigoCV: '',
    status: 'Planejado',
    observacoesGerais: '',
    grupos: []
  };
  const [novoProjeto, setNovoProjeto] = useState(novoProjetoInicial);
  const [novoGrupoNome, setNovoGrupoNome] = useState('');
  const [processosSelecionados, setProcessosSelecionados] = useState([]);
  const [novoGrupoCodigoIM, setNovoGrupoCodigoIM] = useState('');
  const [novoGrupoCodigoCV, setNovoGrupoCodigoCV] = useState('');
  const [logoBase64, setLogoBase64] = useState(null);

  const [openModalAnexos, setOpenModalAnexos] = useState(false);
  const [abrirGPD, setAbrirGPD] = useState(false);
  const [itemEdicao, setItemEdicao] = useState(null);
  
const handleEditarItem = async (item) => {
  try {
    const resposta = await axios.get(`${API_URL}/gpd/itens/${item.id}`);
    if (resposta.data?.item) {
      setItemGPDSelecionado(resposta.data.item); // <- agora sim com histórico atualizado
      setAbrirGPD(true);
    } else {
      alert('Erro ao carregar item do banco.');
    }
  } catch (err) {
    console.error('Erro ao buscar item por ID:', err);
    alert('Erro ao abrir item para edição.');
  }
};

  
  
const [itemGPDSelecionado, setItemGPDSelecionado] = useState(null);


const [abrirPreOrcamento, setAbrirPreOrcamento] = useState(false);
const [dadosPreOrcamento, setDadosPreOrcamento] = useState(null);

const abrirFormularioPreOrcamento = (dados) => {
  console.log("✅ Enviando para Pré-Orçamento:", dados);
  setDadosPreOrcamento(dados);
  setAbrirPreOrcamento(true);
};



const [abaSelecionadaProjetos, setAbaSelecionadaProjetos] = useState('andamento');

const [expandirEmAndamento, setExpandirEmAndamento] = useState(true);
const [expandirConcluidos, setExpandirConcluidos] = useState(true);



// Anexar Arquivos - DESENHO TECNICO PDF
async function handleUploadDesenhoTecnico(event, grupoIdx) {
  const file = event.target.files[0];
  if (!file) return;
  const formData = new FormData();
  formData.append('file', file);

  try {
    setUploading(true);
    const res = await axios.post(`https://projetos.impram.com.br/upload/desenho_tecnico`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });

    setGruposEdicao(prev => {
      const atualizado = [...prev];
      const grupo = { ...atualizado[grupoIdx] };
      grupo.arquivosAnexados = {
        ...grupo.arquivosAnexados,
        desenhoTecnico: res.data.arquivo
      };
      atualizado[grupoIdx] = grupo;
      return atualizado;
    });

  } catch (error) {
    console.error('Erro ao enviar Desenho Técnico:', error);
    alert('Erro ao anexar Desenho Técnico.');
  } finally {
    setUploading(false);
  }
}



async function handleUploadDesenhoIndividual(event, grupoIdx) {
  const file = event.target.files[0];
  if (!file) return;
  const formData = new FormData();
  formData.append('file', file);

  try {
    setUploading(true);
    const res = await axios.post(`https://projetos.impram.com.br/upload/desenho_individual`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });

    setGruposEdicao(prev => {
      const atualizado = [...prev];
      const grupo = { ...atualizado[grupoIdx] };
      grupo.arquivosAnexados = {
        ...grupo.arquivosAnexados,
        desenhoIndividual: res.data.arquivo
      };
      atualizado[grupoIdx] = grupo;
      return atualizado;
    });

  } catch (error) {
    console.error('Erro ao enviar Desenho Individual:', error);
    alert('Erro ao anexar Desenho Individual.');
  } finally {
    setUploading(false);
  }
}



async function handleUploadAnexo1(event, grupoIdx) {
  const file = event.target.files[0];
  if (!file) return;
  const formData = new FormData();
  formData.append('file', file);

  try {
    setUploading(true);
      const res = await axios.post(`https://projetos.impram.com.br/upload/anexos`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });

    setGruposEdicao(prev => {
      const atualizado = [...prev];
      if (!atualizado[grupoIdx]) atualizado[grupoIdx] = {};
      if (!atualizado[grupoIdx].arquivosAnexados) atualizado[grupoIdx].arquivosAnexados = {};

      atualizado[grupoIdx].arquivosAnexados.anexo1 = res.data.arquivo;
      return atualizado;
    });

  } catch (error) {
    console.error('Erro ao enviar Anexo 1:', error);
    alert('Erro ao anexar Anexo 1.');
  } finally {
    setUploading(false);
  }
}


async function handleUploadAnexo2(event, grupoIdx) {
  const file = event.target.files[0];
  if (!file) return;
  const formData = new FormData();
  formData.append('file', file);

  try {
    setUploading(true);
    const res = await axios.post(`https://projetos.impram.com.br/upload/anexos`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
    });

    setGruposEdicao(prev => {
      const atualizado = [...prev];
      if (!atualizado[grupoIdx]) atualizado[grupoIdx] = {};
      if (!atualizado[grupoIdx].arquivosAnexados) atualizado[grupoIdx].arquivosAnexados = {};

      atualizado[grupoIdx].arquivosAnexados.anexo2 = res.data.arquivo;
      return atualizado;
    });

  } catch (error) {
    console.error('Erro ao enviar Anexo 2:', error);
    alert('Erro ao anexar Anexo 2.');
  } finally {
    setUploading(false);
  }
}


async function handleUploadAnexo3(event, grupoIdx) {
  const file = event.target.files[0];
  if (!file) return;
  const formData = new FormData();
  formData.append('file', file);

  try {
    setUploading(true);
    const res = await axios.post(`https://projetos.impram.com.br/upload/anexos`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });

    setGruposEdicao(prev => {
      const atualizado = [...prev];
      if (!atualizado[grupoIdx]) atualizado[grupoIdx] = {};
      if (!atualizado[grupoIdx].arquivosAnexados) atualizado[grupoIdx].arquivosAnexados = {};

      atualizado[grupoIdx].arquivosAnexados.anexo3 = res.data.arquivo;
      return atualizado;
    });

  } catch (error) {
    console.error('Erro ao enviar Anexo 3:', error);
    alert('Erro ao anexar Anexo 3.');
  } finally {
    setUploading(false);
  }
}

const [grupoSelecionadoParaProcessos, setGrupoSelecionadoParaProcessos] = useState(null);
const [processosSelecionadosParaAdicionar, setProcessosSelecionadosParaAdicionar] = useState([]);

  
  function handleVerDesenhoTecnico() {
    window.open('/desenho_tecnico/seuarquivo.pdf', '_blank');
  }
  
  function handleVerDesenhoIndividual() {
    window.open('/desenho_individual/seuarquivo.pdf', '_blank');
  }
  
  function handleVerAnexo1() {
    window.open('/Anexos/seuanexo1.jpg', '_blank');
  }
  function handleVerAnexo2() { /* semelhante */ }
  function handleVerAnexo3() { /* semelhante */ }
  

useEffect(() => {
  if (!usuario) return;


const ehANP = Array.isArray(tiposDoUsuario) && tiposDoUsuario.some(t =>
  [
    "pre_impressao", "impressao", "laminadora", "serigrafia",
    "empastadeira", "acopladeira", "onduladeira", "corte_vinco",
    "hotstamping", "destaques", "fechadora", "caixa_rigida",
    "bancada_rigida", "bancada_diversos", "fresa", "qualidade"
  ].includes(t)
);


const ehProjetos = Array.isArray(tiposDoUsuario) && tiposDoUsuario.includes('projetos');



  if (ehANP) {
    setModoApp('anp');
  } else {
    setModoApp('principal');
    if (ehProjetos) {
      setModo('projetos');
      setTimeout(() => carregarDados(), 100);
    } else {
      setModo('gpd');
      carregarDados();
      carregarDadosGPD();
      getBase64Logo(logoImpram).then(setLogoBase64);
      carregarClientes();
    }
  }
}, [usuario]);



  
  


useEffect(() => {
  if (usuario?.login === 'gerson.souza') {
fetch(`${API_URL}/usuarios`, {
  method: 'GET',
  credentials: 'include', // necessário para cookies e autenticação
  headers: {
    'Content-Type': 'application/json'
  }
})
  .then(res => res.json())
  .then(data => {
    setUsuariosCadastrados(data);
  })
  .catch(err => {
    console.error('Erro ao buscar usuários:', err);
  });

  }
}, [usuario]);



  
  

  useEffect(() => {
    if (usuario) {
      localStorage.setItem('usuarioAtual', JSON.stringify(usuario));
    } else {
      localStorage.removeItem('usuario');
    }
  }, [usuario]);

  useEffect(() => {
    if (usuario) {
      carregarDados();
      getBase64Logo(logoImpram).then(setLogoBase64);
      carregarClientes(); // <-- Aqui carrega do backend!
          if (usuario.login === 'gerson.souza') {
      
    }


    }
  }, [usuario]);

// Atualize a função que carrega os dados de clientes
async function carregarClientes() {
async function carregarUsuarios() {
  try {
    const res = await axios.get(`${API_URL}/usuarios`);
    console.log("🔄 Resultado da API:", res.data); // ← Adicione isso!
    setUsuariosCadastrados(res.data);
  } catch (error) {
    console.error("Erro ao carregar usuários:", error);
    setUsuariosCadastrados([]);
  }
}





  try {
    const res = await axios.get(`${API_URL}/clientes`);
    setClientes(res.data);
  } catch (error) {
    setClientes([]);  // Caso haja erro, não exibe nada
  }
}

async function carregarDadosGPD() {
  try {
    const res = await axios.get(`${API_URL}/gpd/itens`);
    setItensGPD(res.data);
  } catch (err) {
    console.error('Erro ao carregar GPD:', err);
  }
}



  function handleDragEndProcessoGrupo(result, grupoIdx) {
    if (!result.destination) return;
    setGruposEdicao(prev => {
      const copia = [...prev];
      const processosReordenados = reorder(
        copia[grupoIdx].processos,
        result.source.index,
        result.destination.index
      );
      copia[grupoIdx].processos = processosReordenados;
      return copia;
    });
  }

  // >>>> FUNÇÃO CORRIGIDA PARA O NOVO PROJETO <<<<
  function handleDragEndProcessoGrupoNovoProjeto(result, grupoIdx) {
    if (!result.destination) return;
    setNovoProjeto(prev => {
      const gruposAtualizados = [...prev.grupos];
      const processosReordenados = reorder(
        gruposAtualizados[grupoIdx].processos,
        result.source.index,
        result.destination.index
      );
      gruposAtualizados[grupoIdx].processos = processosReordenados;
      return { ...prev, grupos: gruposAtualizados };
    });
  }

  async function handleAdicionarCliente() {
    if (novoCliente.trim() === "") return;
    try {
      await axios.post(`${API_URL}/clientes`, { nome: novoCliente.trim() });
      setTimeout(() => carregarClientes(), 50); // dá tempo de backend salvar      
      setNovoCliente('');
      setAbrirModalCliente(false);
    } catch (err) {
      alert("Erro ao cadastrar cliente: " + (err?.response?.data?.erro || ""));
    }
  }

  async function handleExcluirCliente(clienteParaExcluir) {
    if (!window.confirm(`Deseja realmente excluir o cliente "${clienteParaExcluir}"?`)) return;
    try {
      await axios.delete(`${API_URL}/clientes`, { data: { nome: clienteParaExcluir } });
      setTimeout(() => carregarClientes(), 50);      
    } catch (err) {
      alert("Erro ao excluir cliente: " + (err?.response?.data?.erro || ""));
    }
  }
  

  async function carregarDados() {
    try {
      const [projetosRes, insumosRes] = await Promise.all([
        axios.get(`${API_URL}/projetos`),
        axios.get(`${API_URL}/insumos`),
      ]);
      setProjetos(projetosRes.data);
      setInsumosMap(insumosRes.data);
    } catch (error) {
      console.error('Erro ao carregar dados:', error);
    }
  }

  // Atualiza campos do novo projeto no formulário de cadastro
  function handleChange(e) {
    const { name, value } = e.target;
    setNovoProjeto(prev => ({
      ...prev,
      [name]: value
    }));
  }

  // Adiciona um novo grupo ao projeto em cadastro
  function handleAdicionarGrupo() {
    if (novoGrupoNome.trim() === "" || processosSelecionados.length === 0) return;
    setNovoProjeto(prev => ({
      ...prev,
      grupos: [
        ...prev.grupos,
        {
          nome: novoGrupoNome.trim(),
          processos: criarProcessosSelecionados(processosSelecionados, insumosMap),
          codigoIM: novoGrupoCodigoIM,
          codigoCV: novoGrupoCodigoCV
        }
      ]
    }));
    setNovoGrupoNome('');
    setProcessosSelecionados([]);
    setNovoGrupoCodigoIM('');
    setNovoGrupoCodigoCV('');
  }

  // Remove um grupo do projeto em cadastro
  function handleRemoverGrupo(idx) {
    setNovoProjeto(prev => ({
      ...prev,
      grupos: prev.grupos.filter((_, i) => i !== idx)
    }));
  }

  // Duplicar um grupo do projeto em cadastro
function handleDuplicarGrupo(idx) {
  setNovoProjeto(prev => {
    const grupoParaDuplicar = prev.grupos?.[idx];

    if (!grupoParaDuplicar || typeof grupoParaDuplicar !== 'object') {
      console.warn(`⚠️ Grupo inválido ou inexistente no índice ${idx}, duplicação cancelada.`);
      return prev;
    }

    const novoGrupo = {
      ...grupoParaDuplicar,
      nome: (grupoParaDuplicar.nome || 'Grupo') + ' (Cópia)',
      processos: Array.isArray(grupoParaDuplicar.processos)
        ? grupoParaDuplicar.processos.map(proc => ({ ...proc }))
        : [],
      codigoIM: grupoParaDuplicar.codigoIM || "",
      codigoCV: grupoParaDuplicar.codigoCV || "",
    };

    const novosGrupos = [
      ...prev.grupos.slice(0, idx + 1),
      novoGrupo,
      ...prev.grupos.slice(idx + 1),
    ];

    return {
      ...prev,
      grupos: novosGrupos,
    };
  });
}


  // Adicionar/remover processos dentro do grupo do novo projeto (formulário)
  function handleAdicionarProcessoNovoProjeto(grupoIdx, nomeProcesso) {
    setNovoProjeto(prev => {
      const gruposAtualizados = prev.grupos.map((g, gIdx) => {
        if (gIdx !== grupoIdx) return g;
        return {
          ...g,
          processos: [
            ...g.processos,
            {
              nome: nomeProcesso,
              status: "",
              dataPlanejada: "",
              dataChegadaInsumo: "",
              dataRenegociada: "",
              dataConclusao: "",
              insumo: insumosMap && insumosMap[nomeProcesso] ? insumosMap[nomeProcesso] : "",
              disponibilidade: ""
            }
          ]
        };
      });
      return { ...prev, grupos: gruposAtualizados };
    });
  }
  function handleRemoverProcessoNovoProjeto(grupoIdx, procIdx) {
    setNovoProjeto(prev => {
      const gruposAtualizados = prev.grupos.map((g, gIdx) => {
        if (gIdx !== grupoIdx) return g;
        return {
          ...g,
          processos: g.processos.filter((_, pIdx) => pIdx !== procIdx)
        };
      });
      return { ...prev, grupos: gruposAtualizados };
    });
  }
  function handleChangeProcessoNovoProjeto(grupoIdx, procIdx, campo, valor) {
    setNovoProjeto(prev => {
      const gruposAtualizados = prev.grupos.map((g, gIdx) => {
        if (gIdx !== grupoIdx) return g;
        const processosAtualizados = g.processos.map((p, pIdx) => {
          if (pIdx !== procIdx) return p;
          return { ...p, [campo]: valor };
        });
        return { ...g, processos: processosAtualizados };
      });
      return { ...prev, grupos: gruposAtualizados };
    });
  }


  async function handleDeletarAnexo(tipo, nomeArquivo, grupoIdx) {
    if (!window.confirm('Tem certeza que deseja excluir este anexo?')) return;
    try {
      await axios.delete(`https://projetos.impram.com.br/upload/${tipo}/${nomeArquivo}`);
      setGruposEdicao(prev => {
        const novo = [...prev];
        const arquivos = novo[grupoIdx].arquivosAnexados;
      
        if (tipo === 'desenho_tecnico') {
          arquivos.desenhoTecnico = '';
        } else if (tipo === 'desenho_individual') {
          arquivos.desenhoIndividual = '';
        } else if (tipo === 'anexos') {
          if (arquivos.anexo1 === nomeArquivo) arquivos.anexo1 = '';
          if (arquivos.anexo2 === nomeArquivo) arquivos.anexo2 = '';
          if (arquivos.anexo3 === nomeArquivo) arquivos.anexo3 = '';
        }
      
        return novo;
      });
      
      alert('Arquivo deletado com sucesso!');
    } catch (error) {
      console.error('Erro ao deletar anexo:', error);
      alert('Erro ao deletar anexo.');
    }
  }
  
  


  // Salvar novo projeto ou adicionar grupos a projeto existente
async function handleSubmit(e) {
  e.preventDefault();

  // ⛔️ Verifica se os campos obrigatórios estão preenchidos
  if (
    !novoProjeto.nomeProjeto.trim() ||
    !novoProjeto.cliente.trim() ||
    novoProjeto.grupos.length === 0
  ) {
    alert("Preencha o nome do projeto, cliente e adicione ao menos um grupo com processos.");
    return;
  }

  const nomeNovo = novoProjeto.nomeProjeto.trim().toLowerCase();

    const projetoExistente = projetos.find(
      p => p.nomeProjeto.trim().toLowerCase() === nomeNovo
    );
    if (projetoExistente) {
      const gruposAtualizados = [
        ...(projetoExistente.grupos || []),
        ...(novoProjeto.grupos || [])
      ];
      try {
const dados = {
  ...projetoExistente,
  grupos: gruposAtualizados,
};

console.log('🔍 Enviando dados ao backend:', JSON.stringify(dados, null, 2));

await axios.put(`${API_URL}/projetos/${projetoExistente.id}`, dados);

        carregarDados();
        setNovoProjeto(novoProjetoInicial);
        alert("Os novos grupos foram adicionados ao projeto existente!");
      } catch (error) {
        console.error('Erro ao atualizar projeto existente:', error);
        alert("Erro ao adicionar grupos ao projeto existente.");
      }
    } else {
      try {
        await axios.post(`${API_URL}/projetos`, novoProjeto);

        // Envia também para o ANP
{/*const grupo0 = novoProjeto.grupos && novoProjeto.grupos[0];

if (grupo0 && Array.isArray(grupo0.processos) && grupo0.processos.length > 0) {
const grupoParaSincronizar = novoProjeto.grupos?.[0];

if (
  grupoParaSincronizar &&
  Array.isArray(grupoParaSincronizar.processos) &&
  grupoParaSincronizar.processos.length > 0
) {
  await axios.post(`${API_URL}/anp/sincronizar`, {
    cliente: novoProjeto.cliente,
    codigoIM: grupoParaSincronizar.codigoIM || '',
    descricaoProduto: novoProjeto.nomeProjeto,
    processos: grupoParaSincronizar.processos.map(p => p?.nome || '')
  });
}

}
*/}
        
        carregarDados();
        setNovoProjeto(novoProjetoInicial);

        
        
      } catch (error) {
        console.error('Erro ao salvar projeto:', error);
      }
    }
  }

  // Abertura e fechamento de detalhes/edição do projeto
function handleAbrirDetalhesProjeto(projeto) {
  const gruposEdit = (projeto.grupos || []).map(g => ({
    ...g,
    codigoIM: g.codigoIM || "",
    codigoCV: g.codigoCV || "",
    arquivosAnexados: g.arquivosAnexados || {
      desenhoTecnico: '',
      desenhoIndividual: '',
      anexo1: '',
      anexo2: '',
      anexo3: ''
    }
  }));

  setSelectedProjeto(projeto);
  setEditandoProjeto({ ...projeto, grupos: gruposEdit });
  setGruposEdicao(gruposEdit);
  setNovoGrupoNomeEdicao('');
  setProcessosSelecionadosEdicao([]);
}

  
  function handleFecharDetalhesProjeto() {
    setSelectedProjeto(null);
    setEditandoProjeto(null);
    setGruposEdicao([]);
    setNovoGrupoNomeEdicao('');
    setProcessosSelecionadosEdicao([]);
  }

  // Edição de grupos/processos dentro do projeto já existente (modal)
  function handleChangeProcessoGrupoEdicao(grupoIdx, procIdx, campo, valor) {
    setGruposEdicao(prev => {
      const copia = [...prev];
      copia[grupoIdx].processos[procIdx][campo] = valor;
      return copia;
    });
  }
  function handleChangeNomeGrupoEdicao(grupoIdx, valor) {
    setGruposEdicao(prev => {
      const copia = [...prev];
      copia[grupoIdx].nome = valor;
      return copia;
    });
  }
  function handleChangeCodigoIMGrupoEdicao(grupoIdx, valor) {
    setGruposEdicao(prev => {
      const copia = [...prev];
      copia[grupoIdx].codigoIM = valor;
      return copia;
    });
  }
  function handleChangeCodigoCVGrupoEdicao(grupoIdx, valor) {
    setGruposEdicao(prev => {
      const copia = [...prev];
      copia[grupoIdx].codigoCV = valor;
      return copia;
    });
  }
  function handleAdicionarGrupoNaEdicao() {
    if (novoGrupoNomeEdicao.trim() === "" || processosSelecionadosEdicao.length === 0) return;
    setGruposEdicao(prev => [
      ...prev,
      {
        nome: novoGrupoNomeEdicao.trim(),
        processos: criarProcessosSelecionados(processosSelecionadosEdicao, insumosMap),
        codigoIM: "",
        codigoCV: ""
      }
    ]);
    setNovoGrupoNomeEdicao('');
    setProcessosSelecionadosEdicao([]);
  }
  function handleRemoverGrupoNaEdicao(idx) {
    setGruposEdicao(prev => prev.filter((_, i) => i !== idx));
  }
function handleDuplicarGrupoEdicao(idx) {
  setGruposEdicao(prev => {
    const grupoParaDuplicar = prev?.[idx];

    if (!grupoParaDuplicar || typeof grupoParaDuplicar !== 'object') {
      console.warn(`⚠️ Grupo inválido ou inexistente no índice ${idx}, duplicação cancelada.`);
      return prev;
    }

    const novoGrupo = {
      ...grupoParaDuplicar,
      nome: (grupoParaDuplicar.nome || 'Grupo') + ' (Cópia)',
      processos: Array.isArray(grupoParaDuplicar.processos)
        ? grupoParaDuplicar.processos.map(proc => ({ ...proc }))
        : [],
      codigoIM: grupoParaDuplicar.codigoIM || "",
      codigoCV: grupoParaDuplicar.codigoCV || "",
      arquivosAnexados: {
        desenhoTecnico: '',
        desenhoIndividual: '',
        anexo1: '',
        anexo2: '',
        anexo3: ''
      }
    };

    return [
      ...prev.slice(0, idx + 1),
      novoGrupo,
      ...prev.slice(idx + 1),
    ];
  });
}

  
  

  // Adiciona/remover processo na edição do grupo do projeto
  function handleAdicionarProcessoEdicao(grupoIdx, nomeProcesso) {
    setGruposEdicao(prev => {
      const copia = [...prev];
      copia[grupoIdx].processos = [
        ...copia[grupoIdx].processos,
        {
          nome: nomeProcesso,
          status: "",
          dataPlanejada: "",
          dataChegadaInsumo: "",
          dataRenegociada: "",
          dataConclusao: "",
          insumo: insumosMap && insumosMap[nomeProcesso] ? insumosMap[nomeProcesso] : "",
          disponibilidade: ""
        }
      ];
      return copia;
    });
  }
  function handleRemoverProcessoEdicao(grupoIdx, procIdx) {
    setGruposEdicao(prev => {
      const copia = [...prev];
      copia[grupoIdx].processos = copia[grupoIdx].processos.filter((_, pIdx) => pIdx !== procIdx);
      return copia;
    });
  }

  // Salvar alterações de edição de projeto
async function handleSalvarEdicaoProjeto() {
  try {
    const projetoAtualizado = {
      id: editandoProjeto.id,
      cliente: editandoProjeto.cliente || '',
      nomeProjeto: editandoProjeto.nomeProjeto || '',
      descricaoItem: editandoProjeto.descricaoItem || '',
      codigoIM: editandoProjeto.codigoIM || '',
      codigoCV: editandoProjeto.codigoCV || '',
      status: editandoProjeto.status || 'Planejado',
      observacoesGerais: editandoProjeto.observacoesGerais || '',
      grupos: gruposEdicao.map(grupo => ({
        nome: grupo.nome,
        codigoIM: grupo.codigoIM || '',
        codigoCV: grupo.codigoCV || '',
        processos: grupo.processos.map(proc => ({
          ...proc,
          op: proc.op || ''
        })),
        arquivosAnexados: grupo.arquivosAnexados || {
          desenhoTecnico: '',
          desenhoIndividual: '',
          anexo1: '',
          anexo2: '',
          anexo3: ''
        }
      }))
    };

    await axios.put(`${API_URL}/projetos/${editandoProjeto.id}`, projetoAtualizado);
    carregarDados();
    handleFecharDetalhesProjeto();
  } catch (error) {
    console.error('Erro ao atualizar projeto:', error);
    alert('Erro ao salvar alterações do projeto.');
  }
}

  

  // Excluir projeto inteiro
  async function handleExcluirProjeto(id) {
    const projeto = projetos.find(p => p.id === id);
    if (!projeto) return alert("Projeto não encontrado.");
  
    const nomeProjeto = projeto.nomeProjeto?.trim().toLowerCase();
    const clienteProjeto = projeto.cliente?.trim().toLowerCase();
  
    const idsParaExcluir = projetos
      .filter(p => p.nomeProjeto?.trim().toLowerCase() === nomeProjeto &&
                   p.cliente?.trim().toLowerCase() === clienteProjeto)
      .map(p => p.id);
  
    if (!window.confirm(`Deseja excluir o projeto completo "${projeto.nomeProjeto}" com ${idsParaExcluir.length} etapas?`)) return;
  
    try {
      for (const idExcluir of idsParaExcluir) {
        await axios.delete(`${API_URL}/projetos/${idExcluir}`);
      }
      carregarDados(); // atualiza lista
      alert("Projeto excluído com sucesso!");
    } catch (err) {
      alert("Erro ao excluir o projeto.");
      console.error(err);
    }
  }
  
  

  function handleExcluirTodosAnexosDoGrupo(grupoIdx) {
    const arquivos = gruposEdicao[grupoIdx]?.arquivosAnexados;
    if (!arquivos) return;
  
    const deletarArquivo = async (tipo, nome) => {
      try {
        await axios.delete(`https://projetos.impram.com.br/upload/${tipo}/${nome}`);
      } catch (err) {
        console.warn(`Erro ao excluir ${nome}:`, err);
      }
    };
  
    const promessas = [];
  
    if (arquivos.desenhoTecnico) promessas.push(deletarArquivo('desenho_tecnico', arquivos.desenhoTecnico));
    if (arquivos.desenhoIndividual) promessas.push(deletarArquivo('desenho_individual', arquivos.desenhoIndividual));
    if (arquivos.anexo1) promessas.push(deletarArquivo('anexos', arquivos.anexo1));
    if (arquivos.anexo2) promessas.push(deletarArquivo('anexos', arquivos.anexo2));
    if (arquivos.anexo3) promessas.push(deletarArquivo('anexos', arquivos.anexo3));
  
    Promise.all(promessas).then(() => {
      setGruposEdicao(prev => {
        const atualizado = [...prev];
        atualizado[grupoIdx].arquivosAnexados = {
          desenhoTecnico: '',
          desenhoIndividual: '',
          anexo1: '',
          anexo2: '',
          anexo3: ''
        };
        return atualizado;
      });
    });
  }
  


  async function handleDuplicarProjeto(projeto) {
    // Clona o projeto sem o id, com ajustes
    const novoProjeto = {
      ...projeto,
      nomeProjeto: projeto.nomeProjeto + ' (Cópia)',
      status: 'Planejado',
      grupos: (projeto.grupos || []).map(grupo => ({
        ...grupo,
        processos: (grupo.processos || []).map(proc => ({
          ...proc,
          status: 'Planejado',
          dataPlanejada: '',
          dataChegadaInsumo: '',
          dataRenegociada: '',
          dataConclusao: '',
        }))
      }))
    };
    delete novoProjeto.id;
    try {
      await axios.post(`${API_URL}/projetos`, novoProjeto);
      carregarDados();
      alert('Projeto duplicado com sucesso!');
    } catch (error) {
      alert('Erro ao duplicar projeto');
    }
  }

  // Estilo de linha do processo atual (para piscar)
  function getRowStyle(grupo, procIdx, status) {
    const idxProcessoAtual = grupo.processos.findIndex(p => p.status !== "Concluído");
    const ehAtual = procIdx === idxProcessoAtual;
    let style = {};
    if (status === "Concluído") {
      style.background = "#d4fcd7";
    } else if (ehAtual) {
      style.animation = "pisca 1s infinite";
      style.background = "#ffe888";
    } else {
      style.background = "#ffd6d6";
    }
    return style;
  }

  // Popover com códigos IM/CV do projeto
  function handleOpenCodigos(event, grupos) {
    setCodigosParaMostrar(grupos);
    setAnchorCodigos(event.currentTarget);
  }
  function handleCloseCodigos() {
    setAnchorCodigos(null);
    setCodigosParaMostrar([]);
  }

  // Filtros dos projetos
// Agrupa projetos com mesmo cliente e nomeProjeto
const projetosAgrupados = Object.values(
  projetos.reduce((acc, projeto) => {
    const chave = `${projeto.cliente?.trim().toLowerCase()}|${projeto.nomeProjeto?.trim().toLowerCase()}`;
    if (!acc[chave]) {
      acc[chave] = {
        ...projeto,
        grupos: [...(projeto.grupos || [])]
      };
    } else {
      acc[chave].grupos = acc[chave].grupos.concat(projeto.grupos || []);
    }
    return acc;
  }, {})
);

// Filtro com base nos inputs
const projetosFiltrados = projetosAgrupados.filter(p => {
  const clienteMatch = filtroCliente === '' || (p.cliente && p.cliente.toLowerCase().includes(filtroCliente.toLowerCase()));
  const imMatch =
    filtroIM === '' ||
    (p.codigoIM && p.codigoIM.toLowerCase().includes(filtroIM.toLowerCase())) ||
    (p.grupos && p.grupos.some(g => g.codigoIM && g.codigoIM.toLowerCase().includes(filtroIM.toLowerCase())));
  return clienteMatch && imMatch;
});


  // Separa projetos em andamento e concluídos
  const emAndamento = projetosFiltrados.filter(p =>
    !(p.status === 'Concluído' || (p.grupos && p.grupos.every(g =>
      g.processos && g.processos.length > 0 && g.processos.every(proc => proc.status === "Concluído")
    )))
  );
  const concluidos = projetosFiltrados.filter(p =>
    (p.status === 'Concluído' || (p.grupos && p.grupos.every(g =>
      g.processos && g.processos.length > 0 && g.processos.every(proc => proc.status === "Concluído")
    )))
  );

  // --- Geração do PDF ---
  async function handleExportarPDFProjeto() {
    if (!selectedProjeto) return;

    // Cria o PDF em modo paisagem
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a4",
    });

    let y = 15;
    // Adiciona o logotipo proporcional
    if (logoBase64) {
      await new Promise(resolve => {
        const img = new window.Image();
        img.src = logoBase64;
        img.onload = function () {
          const imgWidth = 30;
          const ratio = img.height / img.width;
          const imgHeight = imgWidth * ratio;
          doc.addImage(logoBase64, 'PNG', (297 - imgWidth) / 2, y, imgWidth, imgHeight);
          y += imgHeight + 4;
          resolve();
        };
        img.onerror = resolve;
      });
    }
    doc.setFontSize(16);
    doc.text(`Projeto: ${selectedProjeto.nomeProjeto || '-'}`, 14, y + 8);
    doc.setFontSize(12);
    doc.text(`Cliente: ${selectedProjeto.cliente || '-'}`, 14, y + 16);
    let currentY = y + 22;

    (selectedProjeto.grupos || []).forEach((grupo, grupoIdx) => {
      doc.setFontSize(13);
      doc.setTextColor(44, 62, 80);
      doc.text(`Grupo ${grupoIdx + 1}: ${grupo.nome || '-'}`, 14, currentY);

      if (grupo.codigoIM || grupo.codigoCV) {
        doc.setFontSize(10);
        doc.text(
          `IM: ${grupo.codigoIM || '-'}   CV: ${grupo.codigoCV || '-'}`,
          220, currentY
        );
      }

      currentY += 6;
      const tableColumns = [
        'Processo', 'Status', 'Data Planejada', 'Data Chegada Insumo',
        'Data Renegociada', 'Data Conclusão', 'Insumo', 'Disponibilidade'
      ];
      const tableRows = grupo.processos.map(proc => [
        proc.nome || '-', proc.status || '-', proc.dataPlanejada || '-', proc.dataChegadaInsumo || '-',
        proc.dataRenegociada || '-', proc.dataConclusao || '-', proc.insumo || '-',
        proc.disponibilidade || '-'
      ]);
      doc.autoTable({
        startY: currentY,
        head: [tableColumns],
        body: tableRows,
        theme: 'grid',
        styles: {
          fontSize: 10,
          cellPadding: 1.8,
          overflow: 'visible',
          halign: 'left',
        },
        columnStyles: {
          0: { cellWidth: 'auto' },
          1: { cellWidth: 'auto' },
          2: { cellWidth: 'auto' },
          3: { cellWidth: 'auto' },
          4: { cellWidth: 'auto' },
          5: { cellWidth: 'auto' },
          6: { cellWidth: 'auto' },
          7: { cellWidth: 'auto' }
        },
        headStyles: { fillColor: [40, 100, 200] },
        margin: { left: 14, right: 14 }
      });
      currentY = doc.lastAutoTable.finalY + 8;
      if (currentY > 190) {
        doc.addPage();
        currentY = 20;
      }
    });
    doc.save(`Projeto_${selectedProjeto.cliente}_${selectedProjeto.nomeProjeto}.pdf`);
  }


  // ---- AUTENTICAÇÃO: LOGIN (DEVE VIR APÓS OS HOOKS) ----
  if (!usuario) {
    return <Login onLogin={setUsuario} />;
  }
  

if (modo === 'preorcamento') {
  return <PreOrcamentoApp setModo={setModo} dadosGPD={dadosPreOrcamento} />;
}






  if (modoApp === 'anp') {
    const tiposUsuario = Array.isArray(usuario?.tipo)
  ? usuario.tipo.filter(t => typeof t === 'string').map(t => t.toLowerCase())
  : typeof usuario?.tipo === 'string'
  ? [usuario.tipo.toLowerCase()]
  : [];

   
  
  const tiposProcessos = [
  "pre_impressao", "impressao", "laminadora", "serigrafia", "empastadeira",
  "acopladeira", "onduladeira", "corte_vinco", "hotstamping", "destaques",
  "fechadora", "caixa_rigida", "bancada_rigida", "bancada_diversos", "fresa", "qualidade"
];

return (
  <>
    {tiposUsuario.some(t => tiposProcessos.includes(t)) ? (
      <button
        onClick={() => setUsuario(null)}
        style={{ padding: '10px 18px', margin: 12, background: '#f55', borderRadius: 6, border: 'none', fontWeight: 'bold', color: 'white' }}
      >
        Sair
      </button>
    ) : (
      <button
        onClick={() => setModoApp('principal')}
        style={{ padding: '10px 18px', margin: 12, background: '#ddd', borderRadius: 6, border: 'none', fontWeight: 'bold' }}
      >
        ← Voltar para o GPD
      </button>
    )}
    <AppANP />
  </>
);

  }
  
  
if (mostrarCadastro) {
  return (
    <Container maxWidth="lg" sx={{ mt: 5 }}>
      <Typography variant="h5" gutterBottom>Cadastro de Novo Usuário</Typography>

      <TextField
        fullWidth
        label="Nome completo"
        value={novoUsuario.nome}
        onChange={e => setNovoUsuario({ ...novoUsuario, nome: e.target.value })}
        sx={{ mb: 2 }}
      />
      <TextField
        fullWidth
        label="Login"
        value={novoUsuario.login}
        onChange={e => setNovoUsuario({ ...novoUsuario, login: e.target.value })}
        sx={{ mb: 2 }}
      />
      <TextField
        fullWidth
        label="Senha"
        type="password"
        value={novoUsuario.senha}
        onChange={e => setNovoUsuario({ ...novoUsuario, senha: e.target.value })}
        sx={{ mb: 2 }}
      />
      <TextField
        fullWidth
        label="Tipo de usuário"
        value={novoUsuario.tipo}
        onChange={e => setNovoUsuario({ ...novoUsuario, tipo: e.target.value })}
        sx={{ mb: 2 }}
      />
      <Button
        variant="contained"
        color="primary"
        fullWidth
        onClick={async () => {
          try {
            const response = await axios.post(`${API_URL}/usuarios`, novoUsuario);
            alert('Usuário cadastrado com sucesso!');
            setMostrarCadastro(false);
          } catch (error) {
            console.error("Erro ao cadastrar usuário:", error);
            alert('Usuário já cadastrado.');

          }
        }}
      >
        Salvar Novo Usuário
      </Button>
      <Button
        variant="outlined"
        fullWidth
        sx={{ mt: 2 }}
        onClick={() => setMostrarCadastro(false)}
      >
        Voltar
      </Button>

      {usuario?.login === 'gerson.souza' && usuariosCadastrados.length > 0 && (
        <Box sx={{ mt: 6 }}>
      <Typography variant="subtitle1" gutterBottom>
        Usuários Cadastrados ({usuariosCadastrados.length})
      </Typography>


          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
            <TextField
              label="Filtrar por tipo"
              variant="outlined"
              size="small"
              value={filtroTipo}
              onChange={e => setFiltroTipo(e.target.value)}
            />
          </Box>

          <TableContainer component={Paper} sx={{ mb: 3, overflowX: 'auto' }}>
            <Table size="small" sx={{ minWidth: '100%' }}>
              <TableHead>
                <TableRow>
                  <TableCell><strong>Nome</strong></TableCell>
                  <TableCell><strong>Login</strong></TableCell>
                  <TableCell><strong>Senha</strong></TableCell>
                  <TableCell><strong>Tipo</strong></TableCell>
                  <TableCell><strong>Ações</strong></TableCell>

                </TableRow>
              </TableHead>



<TableBody>
  {usuariosCadastrados
.filter(u => {
  const tiposU = Array.isArray(u.tipo)
  ? u.tipo.filter(t => typeof t === 'string').map(t => t.toLowerCase())
  : typeof u.tipo === 'string'
  ? [u.tipo.toLowerCase()]
  : [];

const tiposLogado = Array.isArray(usuario?.tipo)
  ? usuario.tipo.filter(t => typeof t === 'string').map(t => t.toLowerCase())
  : typeof usuario?.tipo === 'string'
  ? [usuario.tipo.toLowerCase()]
  : [];


  if (tiposLogado.includes('admin')) return true;

  return tiposU.some(t => tiposLogado.includes(t));
})



    .map((u, index) => (
      <TableRow key={index}>
        <TableCell>{u.nome}</TableCell>
        <TableCell>{u.login}</TableCell>
        <TableCell>{u.senha}</TableCell>
        <TableCell>
          <FormControl fullWidth size="small">
            <Select
              multiple
              value={u.tipo}
              onChange={(e) => {
                const novoTipo = typeof e.target.value === 'string'
                  ? e.target.value.split(',')
                  : e.target.value;

                setUsuariosCadastrados(prev => prev.map(user =>
                  user.login === u.login ? { ...user, tipo: novoTipo } : user
                ));
              }}
              renderValue={(selected) => selected.join(', ')}
            >
              <MenuItem value="admin">admin</MenuItem>
              <MenuItem value="comercial">comercial</MenuItem>
              <MenuItem value="projetos">projetos</MenuItem>
              <MenuItem value="gpd">gpd</MenuItem>
              <MenuItem value="qualidade">qualidade</MenuItem>
              <MenuItem value="pre_impressao">pre_impressao</MenuItem>
              <MenuItem value="impressao">impressao</MenuItem>
              <MenuItem value="laminadora">laminadora</MenuItem>
              <MenuItem value="serigrafia">serigrafia</MenuItem>
              <MenuItem value="empastadeira">empastadeira</MenuItem>
              <MenuItem value="acopladeira">acopladeira</MenuItem>
              <MenuItem value="onduladeira">onduladeira</MenuItem>
              <MenuItem value="corte_vinco">corte_vinco</MenuItem>
              <MenuItem value="hotstamping">hotstamping</MenuItem>
              <MenuItem value="destaques">destaques</MenuItem>
              <MenuItem value="fechadora">fechadora</MenuItem>
              <MenuItem value="caixa_rigida">caixa_rigida</MenuItem>
              <MenuItem value="bancada_rigida">bancada_rigida</MenuItem>
              <MenuItem value="bancada_diversos">bancada_diversos</MenuItem>
              <MenuItem value="fresa">fresa</MenuItem>
            </Select>
          </FormControl>
        </TableCell>
        <TableCell>
          <Button
            variant="outlined"
            color="success"
            size="small"
            onClick={async () => {
              try {
                await axios.put(`${API_URL}/usuarios/${u.login}`, {
                  ...u,
                  tipo: u.tipo // ← NÃO use trim, pois agora é array
                });
                alert('Tipo do usuário atualizado com sucesso!');
              } catch (err) {
                console.error('Erro ao atualizar tipo:', err);
                alert('Erro ao atualizar tipo do usuário.');
              }
            }}
            sx={{ mr: 1 }}
          >
            Salvar
          </Button>
          <Button
            variant="outlined"
            color="error"
            size="small"
            onClick={async () => {
              if (window.confirm(`Tem certeza que deseja excluir o usuário "${u.login}"?`)) {
                try {
                  await axios.delete(`${API_URL}/usuarios/${u.login}`);
                  alert('Usuário excluído com sucesso!');
                  setUsuariosCadastrados(prev => prev.filter(user => user.login !== u.login));
                } catch (err) {
                  console.error('Erro ao excluir usuário:', err);
                  alert('Erro ao excluir usuário.');
                }
              }
            }}
          >
            Excluir
          </Button>
        </TableCell>
      </TableRow>
    ))}
</TableBody>




            </Table>
          </TableContainer>
        </Box>
      )}
    </Container>
  );
}







  return (
    <Container maxWidth="xl">
  
  <Grid container justifyContent="space-between" alignItems="center" sx={{ mt: 2, mb: 2 }}>
    <Grid item>
      
      <Typography variant="h4" gutterBottom>
        {modo === 'gpd' ? 'GPD - Gerenciador P&D' : 'Gerenciador de Novos Projetos'}
      </Typography>

{modo === 'gpd' && (
  <Button
    variant="outlined"
    color="success"
    sx={{ mt: 1, mb: 1, mr: 2 }}
    onClick={() => setModo('preorcamento')}
  >
    Acessar Pré Orçamento
  </Button>
)}



      <Typography variant="subtitle2" color="primary">
        Usuário logado: <b>{usuario?.nome}</b>
      </Typography>
    </Grid>
    <Grid item>


{usuario?.nome?.toLowerCase().trim() === 'gerson de souza' && (
  <Button
    color="primary"
    variant="contained"
    onClick={() => setMostrarCadastro(prev => !prev)}
    sx={{ mr: 2 }}
  >
    {mostrarCadastro ? 'Fechar Cadastro' : 'Cadastrar Usuário'}
   
  </Button>
)}





<Button
  color="secondary"
  variant="outlined"
  onClick={() => setUsuario(null)}
  sx={{ mr: 2 }}
>
  Sair
</Button>





<Button
  color="primary"
  variant="contained"
  onClick={() => setModoApp('anp')}
  sx={{ ml: 2 }}
>
  Acessar ANP
</Button>



    </Grid>
  </Grid>

  <Box sx={{ mb: 3 }}>
{modo === 'gpd' && (() => {
  const tipos = Array.isArray(usuario?.tipo)
    ? usuario.tipo.filter(t => typeof t === 'string').map(t => t.toLowerCase())
    : typeof usuario?.tipo === 'string'
    ? [usuario.tipo.toLowerCase()]
    : [];

  return !tipos.includes('projetos');
})() && (


  
  <Button
    variant="contained"
    color="primary"
    sx={{ fontWeight: 600, mb: 3 }}
    onClick={() => {
      setModo('projetos');
      setTimeout(() => carregarDados(), 100);
    }}
  >
    Gerenciar Novos Projetos
  </Button>
)}




{modo === 'projetos' && (() => {
  const tipos = Array.isArray(usuario?.tipo)
    ? usuario.tipo.filter(t => typeof t === 'string').map(t => t.toLowerCase())
    : typeof usuario?.tipo === 'string'
    ? [usuario.tipo.toLowerCase()]
    : [];

  return !tipos.includes('projetos');
})() && (
  <Button
    variant="outlined"
    color="secondary"
    onClick={() => setModo('gpd')}
    sx={{ fontWeight: 600, mb: 3 }}
  >
    Voltar para o GPD
  </Button>
)}



</Box>



{modo === 'gpd' && (() => {
  const tipos = Array.isArray(usuario?.tipo)
    ? usuario.tipo.map(t => typeof t === 'string' ? t.toLowerCase() : '')
    : typeof usuario?.tipo === 'string'
    ? [usuario.tipo.toLowerCase()]
    : [];

  return !tipos.includes('projetos');
})() && (

  <Box sx={{ mb: 3 }}>
    <Button
      variant="contained"
      color="primary"
      sx={{ mb: 2 }}
      onClick={() => {
        setItemGPDSelecionado(null);
        setAbrirGPD(true);
      }}
    >
      Cadastrar IM
    </Button>

    <Dialog
  open={abrirGPD}
  onClose={() => setAbrirGPD(false)}
  maxWidth="lg"
  fullWidth
  TransitionProps={{
    timeout: 500,
  }}
>
<DialogTitle>
  {itemGPDSelecionado ? 'Editar Cadastro GPD' : 'Novo Cadastro GPD'}
</DialogTitle>




<DialogContent>
<FormularioGPD
  onSalvar={async (itemSalvo) => {
    try {
      console.log('📦 itemSalvo recebido em onSalvar:', itemSalvo); // debug

      let itemRecarregado = null;

      if (itemSalvo?.id) {
        const res = await axios.get(`${API_URL}/gpd/itens/${itemSalvo.id}`);
        itemRecarregado = res.data?.item;
      } else if (itemSalvo?.im) {
        const resPorIM = await axios.get(`${API_URL}/gpd/itens?im=${itemSalvo.im}`);
        const encontrado = resPorIM.data.find(i => i.im === itemSalvo.im);
        if (encontrado?.id) {
          const res = await axios.get(`${API_URL}/gpd/itens/${encontrado.id}`);
          itemRecarregado = res.data?.item;
        }
      }

      if (!itemRecarregado) throw new Error("Item não encontrado após salvar");

      if (typeof itemRecarregado.historicoAlteracoes === 'string') {
        try {
          itemRecarregado.historicoAlteracoes = JSON.parse(itemRecarregado.historicoAlteracoes);
        } catch {
          itemRecarregado.historicoAlteracoes = [];
        }
      }

      setItemGPDSelecionado({ ...itemRecarregado, _forcarRerender: Date.now() });
      await carregarDadosGPD();

      setAbrirGPD(false);
      setTimeout(() => {
        setItemGPDSelecionado(null);
      }, 300);

    } catch (error) {
      console.error('Erro ao revalidar item após salvar:', error);
      alert('Erro ao recarregar item salvo.');
    }
  }}


  onVoltar={() => {
    setAbrirGPD(false);

    // Aguarda o modal fechar completamente ANTES de limpar o item selecionado
    setTimeout(() => {
      // Só zera se o modal ainda estiver fechado
      if (!abrirGPD) {
        setItemGPDSelecionado(null);
      }
    }, 400); // tempo um pouco maior por segurança
  }}

  itemEdicao={itemGPDSelecionado}
  clientes={clientes}
  carregarClientes={carregarClientes}
  usuario={usuario}
  onAtualizarProjetos={carregarDados}
  onAbrirPreOrcamento={abrirFormularioPreOrcamento}

/>


</DialogContent>


    </Dialog>
<TabelaGPD
  itens={itensGPD}
onEditar={async (item) => {
  try {
    const res = await axios.get(`${API_URL}/gpd/itens/${item.id}`);
    const atualizado = res.data?.item || item;
    setItemGPDSelecionado({ ...atualizado, _forcarRerender: Date.now() });
    setAbrirGPD(true);
  } catch (err) {
    console.error('❌ Erro ao buscar item por ID:', err);
    setItemGPDSelecionado(item);
    setAbrirGPD(true);
  }
}}


  onDuplicar={handleDuplicarProjeto}
  onExcluir={handleExcluirProjeto}
  onAtualizar={carregarDadosGPD}
  usuario={usuario}
/>

  </Box>
)}


  
      <Dialog open={abrirModalCliente} onClose={() => setAbrirModalCliente(false)}>
        <DialogTitle>Clientes Cadastrados</DialogTitle>
        <DialogContent dividers>
          {/* Listagem dos clientes já cadastrados */}
          {clientes.length === 0 && (
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              Nenhum cliente cadastrado.
            </Typography>
          )}
          {clientes.map((cliente, idx) => (
            <Grid container key={idx} alignItems="center" spacing={1} sx={{ mb: 1 }}>
              <Grid item xs>
                <Typography>{cliente}</Typography>
              </Grid>
              <Grid item>
              {tiposDoUsuario.some(t => ['admin', 'projetos', 'qualidade'].includes(t)) ? (
                <Button
                  size="small"
                  color="error"
                  variant="outlined"
                  onClick={() => handleExcluirCliente(cliente)}
                  sx={{ ml: 1 }}
                >
                  Excluir
                </Button>
              ) : null}
            </Grid>

            </Grid>
          ))}

          {/* Cadastro de novo cliente */}
          <Typography variant="subtitle2" sx={{ mt: 2 }}>
            Adicionar Novo Cliente
          </Typography>
          <TextField
            autoFocus
            margin="dense"
            label="Nome do Cliente"
            type="text"
            fullWidth
            value={novoCliente}
            onChange={e => setNovoCliente(e.target.value)}
            sx={{ mt: 1 }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAbrirModalCliente(false)}>Fechar</Button>
          <Button onClick={handleAdicionarCliente} variant="contained" color="primary">
            Salvar Cliente
          </Button>
        </DialogActions>
      </Dialog>
      {modo === 'projetos' && (
        <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
{(tiposDoUsuario.some(t => ['admin', 'projetos', 'qualidade'].includes(t))) && (  <Button
    variant="contained"
    color="primary"
    sx={{ fontWeight: 600 }}
    onClick={() => setAbrirCadastro(true)}
  >
    Criar Novo Projeto
  </Button>
)}


</Box>



      )}
      {abrirCadastro && (
        <Paper elevation={3} sx={{ p: 2, mb: 3 }}>
          <Typography variant="h6" gutterBottom>
            Adicionar Novo Projeto
          </Typography>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={1}>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={6} md={4}>
                

              <Autocomplete
                freeSolo
                options={clientes}
                value={novoProjeto.cliente}
                onChange={(e, newValue) => {
                  if (typeof newValue === 'string') {
                    setNovoProjeto(prev => ({ ...prev, cliente: newValue }));
                  }
                }}
                onInputChange={(e, newInputValue) => {
                  setNovoProjeto(prev => ({ ...prev, cliente: newInputValue }));
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Cliente"
                    fullWidth
                    required
                  />
                )}
              />

                  <Button
                    size="small"
                    variant="outlined"
                    color="primary"
                    onClick={() => setAbrirModalCliente(true)}
                    sx={{ mt: 1 }}
                  >
                    Cadastrar Cliente
                  </Button>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <TextField label="Nome do Projeto" name="nomeProjeto" value={novoProjeto.nomeProjeto} onChange={handleChange} fullWidth required />
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <TextField label="OP" name="op" value={novoProjeto.op} onChange={handleChange} fullWidth />
                </Grid>

              </Grid>
              <Grid item xs={12}>
                <Typography variant="subtitle1">Descrição do Item</Typography>
                <Grid container spacing={1} alignItems="center">
                  <Grid item xs={12} sm={4} md={3}>
                    <TextField
                      label="Nome do Grupo"
                      value={novoGrupoNome}
                      onChange={e => setNovoGrupoNome(e.target.value)}
                      fullWidth
                      inputProps={{ maxLength: 80 }}
                      sx={{ maxWidth: 520, minWidth: 180 }}
                    />
                  </Grid>
                  <Grid item xs={6} sm={2} md={1.5}>



                                  <TextField
                  label="Código IM"
                  value={novoGrupoCodigoIM}
                  onChange={e => {
                    const valor = e.target.value.toUpperCase().replace(/^IM/, '');
                    const numeros = valor.replace(/[^0-9]/g, '').slice(0, 4);
                    const letras = valor.replace(/[^A-Z]/g, '').slice(0, 2);
                    let novo = 'IM';
                    if (numeros.length > 0) novo += numeros;
                    if (numeros.length === 4 && letras.length > 0) novo += letras;
                    setNovoGrupoCodigoIM(novo);
                  }}
                  fullWidth
                  inputProps={{ maxLength: 20 }}
                />


                  </Grid>
                  <Grid item xs={6} sm={2} md={1.5}>


<TextField
  label="Código CV"
  placeholder="Ex: CV1234.ABC123"
  value={novoGrupoCodigoCV}
  onChange={e => {
    let raw = e.target.value.toUpperCase().replace(/^CV/i, '');

    if (raw.length <= 4) {
      const apenasNumeros = raw.replace(/[^0-9]/g, '').slice(0, 4);
      setNovoGrupoCodigoCV('CV' + apenasNumeros);
    } else {
      const numeros = raw.slice(0, 4).replace(/\D/g, '');
      const resto = raw.slice(4);
      const letras = resto.replace(/[^A-Z]/g, '').slice(0, 3);
      const numerosFinais = resto.slice(3).replace(/\D/g, '').slice(0, 3);

      let novoValor = `CV${numeros}`;
      if (letras.length > 0 || numerosFinais.length > 0) {
        novoValor += `.${letras}${numerosFinais}`;
      }

      setNovoGrupoCodigoCV(novoValor);
    }
  }}
  fullWidth
  inputProps={{ maxLength: 20 }}
/>


                  </Grid>
                  <Grid item xs={12} sm={4} md={3}>
                    <FormControl fullWidth sx={{ minWidth: 180, maxWidth: 320 }}>
                      <InputLabel>Processos do Grupo</InputLabel>
                      <Select
                        multiple
                        value={processosSelecionados}
                        onChange={e => setProcessosSelecionados(e.target.value)}
                        renderValue={selected => selected.join(', ')}
                        sx={{ minWidth: 160 }}
                        MenuProps={{ PaperProps: { sx: { minWidth: 200 } } }}
                      >
                        {nomesProcessos.map(proc => (
                          <MenuItem key={proc} value={proc}>
                        <Checkbox
                          checked={processosSelecionados.includes(proc)}
                          disableRipple
                          size="small"
                          sx={{ p: 0, pr: 1 }}
                        />

                            {proc}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={12} md={3}>
                    <Grid container spacing={1}>
                      <Grid item>
                        <Button
                          variant="outlined"
                          startIcon={<AddIcon />}
                          onClick={handleAdicionarGrupo}
                          sx={{ minWidth: 140 }}
                        >
                          SALVAR PROCESSOS
                        </Button>
                      </Grid>
                      <Grid item>
                        <Button
                          type="submit"
                          variant="contained"
                          color="primary"
                          sx={{ minWidth: 140 }}
                        >
                          Salvar Projeto
                        </Button>
                      </Grid>
                      <Grid item>
                        <Button
                          variant="outlined"
                          color="secondary"
                          onClick={() => setAbrirCadastro(false)}
                        >
                          Cancelar
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid container spacing={1} sx={{ mt: 1 }}>
                  {novoProjeto.grupos.map((grupo, grupoIdx) => (
                    <Grid item xs={12} key={grupoIdx}>
                      <Paper elevation={2} sx={{ p: 2 }}>
                        <Grid container alignItems="center" justifyContent="space-between">
                          <Grid item>
                            <Typography variant="subtitle2">{grupo.nome}</Typography>
                          </Grid>
                          <Grid item>



<IconButton
  color="primary"
  onClick={() => {
    setGrupoSelecionadoParaProcessos(grupoIdx);
    setProcessosSelecionadosParaAdicionar([]);
  }}
  title="Adicionar Processos"
>
  <AddIcon />
</IconButton>

<IconButton
  color="secondary"
  onClick={() => handleDuplicarGrupoEdicao(grupoIdx)}
  title="Duplicar Grupo"
>
  <ContentCopyIcon />
</IconButton>


                            <IconButton color="error" onClick={() => handleRemoverGrupo(grupoIdx)}>
                              <DeleteIcon />
                            </IconButton>
                          </Grid>
                        </Grid>
                        <div style={{ overflowX: 'auto', maxWidth: '100vw' }}>
                          <Table size="small">
                            <TableHead>
                              <TableRow>
                                <TableCell>Processo</TableCell>
                                <TableCell>Status</TableCell>
                                <TableCell>Data Planejada</TableCell>
                                <TableCell>Data Chegada Insumo</TableCell>
                                <TableCell>Data Renegociada</TableCell>
                                <TableCell>Data Conclusão</TableCell>
                                <TableCell>Insumo</TableCell>
                                <TableCell>Disponibilidade</TableCell>
                                <TableCell>OP</TableCell>
                                <TableCell>Comentários</TableCell>
                                <TableCell></TableCell>
                              </TableRow>
                            </TableHead>
                            <DragDropContext onDragEnd={result => handleDragEndProcessoGrupoNovoProjeto(result, grupoIdx)}>
  <Droppable droppableId={`novo-grupo-${grupoIdx}`}>
    {provided => (
      <TableBody ref={provided.innerRef} {...provided.droppableProps}>
        {grupo.processos.map((proc, procIdx) => {
          const rowStyle = getRowStyle(grupo, procIdx, proc.status);
          return (
            <Draggable key={procIdx + '-' + proc.nome} draggableId={`novo-${grupoIdx}-${procIdx}`} index={procIdx}>
              {providedDraggable => (
                <TableRow
                  ref={providedDraggable.innerRef}
                  {...providedDraggable.draggableProps}
                  {...providedDraggable.dragHandleProps}
                  style={{
                    ...rowStyle,
                    ...providedDraggable.draggableProps.style,
                    cursor: 'grab'
                  }}
                >
                  {/* Suas células normalmente aqui, igual estava antes */}
                  <TableCell>{proc.nome}</TableCell>
                  {/* ...restante das células */}
                  <TableCell>
                    <FormControl size="small" fullWidth>
                      <Select
                        value={proc.status}
                        onChange={e => handleChangeProcessoNovoProjeto(grupoIdx, procIdx, 'status', e.target.value)}
                      >
                        <MenuItem value="">Selecione</MenuItem>
                        <MenuItem value="Planejado">Planejado</MenuItem>
                        <MenuItem value="Em curso">Em curso</MenuItem>
                        <MenuItem value="Pendente">Pendente</MenuItem>
                        <MenuItem value="Concluído">Concluído</MenuItem>
                      </Select>
                    </FormControl>
                  </TableCell>
                  <TableCell>
                    <TextField type="date" size="small" value={proc.dataPlanejada} onChange={e => handleChangeProcessoNovoProjeto(grupoIdx, procIdx, 'dataPlanejada', e.target.value)} />
                  </TableCell>
                  <TableCell>
                    <TextField type="date" size="small" value={proc.dataChegadaInsumo} onChange={e => handleChangeProcessoNovoProjeto(grupoIdx, procIdx, 'dataChegadaInsumo', e.target.value)} />
                  </TableCell>
                  <TableCell>
                    <TextField type="date" size="small" value={proc.dataRenegociada} onChange={e => handleChangeProcessoNovoProjeto(grupoIdx, procIdx, 'dataRenegociada', e.target.value)} />
                  </TableCell>
                  <TableCell>
                    <TextField type="date" size="small" value={proc.dataConclusao} onChange={e => handleChangeProcessoNovoProjeto(grupoIdx, procIdx, 'dataConclusao', e.target.value)} />
                  </TableCell>
                  <TableCell>
                    <FormControl size="small" fullWidth>
                      <Select
                        value={proc.disponibilidade}
                        onChange={e => handleChangeProcessoNovoProjeto(grupoIdx, procIdx, 'disponibilidade', e.target.value)}
                      >
                        <MenuItem value="">Selecione</MenuItem>
                        <MenuItem value="Disponível">Disponível</MenuItem>
                        <MenuItem value="Indisponível">Indisponível</MenuItem>
                      </Select>
                    </FormControl>
                  </TableCell>
                  <TableCell>
                    <IconButton color="error" onClick={() => handleRemoverProcessoNovoProjeto(grupoIdx, procIdx)} size="small">
                      <DeleteIcon fontSize="inherit" />
                    </IconButton>
                    <FormControl size="small" sx={{ minWidth: 40 }}>
                      <Select
                        displayEmpty
                        value=""
                        onChange={e => handleAdicionarProcessoNovoProjeto(grupoIdx, e.target.value)}
                        renderValue={() => <AddIcon fontSize="inherit" />}
                      >
                        <MenuItem value="" disabled>
                          Adicionar Processo
                        </MenuItem>
                        {nomesProcessos.filter(
                          p => !grupo.processos.some(procEx => procEx.nome === p)
                        ).map(procNome => (
                          <MenuItem key={procNome} value={procNome}>
                            {procNome}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </TableCell>
                </TableRow>
              )}
            </Draggable>
          );
        })}
        {provided.placeholder}
      </TableBody>
    )}
  </Droppable>
</DragDropContext>
                          </Table>
                        </div>
                      </Paper>
                    </Grid>
                  ))}

                </Grid>
              </Grid>
            </Grid>
          </form>
        </Paper>
      )}



{modo === 'projetos' && (
  <Grid container spacing={2} sx={{ mb: 2 }} alignItems="center">
    <Grid item xs={12} sm={6} md={3}>
      <TextField
        label="Buscar por IM"
        value={filtroIM}
        onChange={e => setFiltroIM(e.target.value)}
        fullWidth
      />
    </Grid>
    <Grid item xs={12} sm={6} md={3}>
      <TextField
        label="Buscar por Cliente"
        value={filtroCliente}
        onChange={e => setFiltroCliente(e.target.value)}
        fullWidth
      />
    </Grid>
    <Grid item xs={12} sm={6} md={2}>
      <Button
        variant="contained"
        color="primary"
        onClick={() => {
          setFiltroIM(filtroIM);
          setFiltroCliente(filtroCliente);
        }}
        fullWidth
        sx={{ height: '100%' }}
      >
        Buscar
      </Button>
    </Grid>
  </Grid>
)}


      {/* Tabela Projetos Em Andamento */}
      {modo === 'projetos' && (
  <>
    <Button
      onClick={() => setExpandirEmAndamento(prev => !prev)}
      variant="outlined"
      fullWidth
      sx={{
        textAlign: 'left',
        justifyContent: 'space-between',
        fontWeight: 'bold',
        mb: 1,
        backgroundColor: expandirEmAndamento ? '#e3f2fd' : '#f5f5f5',
        color: expandirEmAndamento ? '#0d47a1' : '#444'
      }}
      endIcon={expandirEmAndamento ? <ExpandLessIcon /> : <ExpandMoreIcon />}
    >
      Projetos Em Andamento Novos Projetos ({emAndamento.length})
    </Button>

    <Collapse in={expandirEmAndamento}>
      <TableContainer component={Paper} sx={{ mb: 4 }}>
        <Table size="small">
          <TableHead>
<TableRow>
  <TableCell>Cliente</TableCell>
  <TableCell>OP</TableCell>
  <TableCell>Projeto</TableCell>
  <TableCell>Códigos IM/CV</TableCell>
  <TableCell>Processo Atual</TableCell>
  <TableCell>Data de Conclusão</TableCell>
  <TableCell>Dias Corridos</TableCell>
</TableRow>

          </TableHead>
          <TableBody>
            {emAndamento.map(projeto => {
              let processoAtual = "Finalizado";
              let dataConclusao = "";
              let dataInicio = null;
              let dataUltimaConclusao = null;

              projeto.grupos?.forEach(grupo => {
                grupo.processos?.forEach(proc => {
                  if (!dataInicio && proc.dataPlanejada) {
                    dataInicio = proc.dataPlanejada;
                  }
                  if (!proc.dataConclusao && processoAtual === "Finalizado") {
                    processoAtual = proc.nome;
                  }
                  if (proc.dataConclusao) {
                    if (!dataUltimaConclusao || proc.dataConclusao > dataUltimaConclusao) {
                      dataUltimaConclusao = proc.dataConclusao;
                    }
                  }
                });
              });

              if (dataUltimaConclusao) {
                dataConclusao = dataUltimaConclusao;
              }

              let menorDataPlanejada = null;
              let maiorDataConclusao = null;

              projeto.grupos?.forEach(grupo => {
                grupo.processos?.forEach(proc => {
                  if (proc.dataPlanejada) {
                    if (!menorDataPlanejada || proc.dataPlanejada < menorDataPlanejada) {
                      menorDataPlanejada = proc.dataPlanejada;
                    }
                  }
                  if (proc.dataConclusao) {
                    if (!maiorDataConclusao || proc.dataConclusao > maiorDataConclusao) {
                      maiorDataConclusao = proc.dataConclusao;
                    }
                  }
                });
              });

              let diasCorridos = "";
              if (menorDataPlanejada) {
                const dtIni = new Date(menorDataPlanejada);
                const dtFim = maiorDataConclusao ? new Date(maiorDataConclusao) : new Date();
                diasCorridos = Math.max(0, Math.ceil((dtFim - dtIni) / (1000 * 60 * 60 * 24)));
              }

              const codigosDoProjeto = (projeto.grupos || []).map(g => ({
                nome: g.nome,
                codigoIM: g.codigoIM,
                codigoCV: g.codigoCV
              }));

              return (
                <TableRow key={projeto.id}>
                  <TableCell>{projeto.cliente}</TableCell>

<TableCell>
  {(() => {
    for (const grupo of projeto.grupos || []) {
      for (const proc of grupo.processos || []) {
        if (proc.op) return proc.op;
      }
    }
    return '-';
  })()}
</TableCell>



                  


                  <TableCell
  sx={{
    maxWidth: 240,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontWeight: 500
  }}
>
  {projeto.nomeProjeto}
</TableCell>


                  
                  
                  <TableCell>
                    <Button
                      size="small"
                      variant="outlined"
                      onClick={e => handleOpenCodigos(e, codigosDoProjeto)}
                      sx={{ minWidth: 88, fontWeight: 600, borderRadius: 2, border: '1.5px solid #444', color: '#1a237e' }}
                    >
                      {codigosDoProjeto.length} {codigosDoProjeto.length === 1 ? 'ETAPA' : 'ETAPAS'}
                    </Button>
                  </TableCell>
                  <TableCell>{processoAtual}</TableCell>

                  <TableCell>{formatarDataBR(dataConclusao) || "-"}</TableCell>
                  <TableCell>{diasCorridos}</TableCell>
                    <TableCell>
                    <Button
                      size="small"
                      variant="outlined"
                      onClick={() => handleAbrirDetalhesProjeto(projeto)}
                      sx={{ mr: 1 }}
                    >
                      Ver Detalhes
                    </Button>

                    {(tiposDoUsuario.some(t => ['admin', 'projetos', 'qualidade'].includes(t))) && (
                      <>
                        <Button
                          size="small"
                          variant="outlined"
                          color="secondary"
                          onClick={() => handleDuplicarProjeto(projeto)}
                          sx={{ mr: 1 }}
                          title="Duplicar Projeto"
                        >
                          Copiar
                        </Button>
                        <IconButton
                          size="small"
                          color="error"
                          onClick={() => handleExcluirProjeto(projeto.id)}
                          title="Excluir Projeto"
                        >
                          <DeleteIcon />
                        </IconButton>
                      </>
                    )}
                  </TableCell>
                </TableRow>
              );
            })}
            {emAndamento.length === 0 && (
              <TableRow>
                <TableCell colSpan={8} align="center">
                  Nenhum projeto em andamento.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Collapse>
  </>
)}



      {/* Tabela Projetos Concluídos */}
      {modo === 'projetos' && (
  <>
    <Button
      onClick={() => setExpandirConcluidos(prev => !prev)}
      variant="outlined"
      fullWidth
      sx={{
        textAlign: 'left',
        justifyContent: 'space-between',
        fontWeight: 'bold',
        mb: 1,
        backgroundColor: expandirConcluidos ? '#e3f2fd' : '#f5f5f5',
        color: expandirConcluidos ? '#0d47a1' : '#444'
      }}
      endIcon={expandirConcluidos ? <ExpandLessIcon /> : <ExpandMoreIcon />}
    >
      Projetos Concluídos Novos Projetos ({concluidos.length})
    </Button>

    <Collapse in={expandirConcluidos}>
      <TableContainer component={Paper} sx={{ mb: 4 }}>
        <Table size="small">
          <TableHead>
<TableRow>
  <TableCell>Cliente</TableCell>
  <TableCell>OP</TableCell>
  <TableCell>Projeto</TableCell>
  <TableCell>Códigos IM/CV</TableCell>
  <TableCell>Processo Atual</TableCell>
  <TableCell>Data de Conclusão</TableCell>
  <TableCell>Dias Corridos</TableCell>
</TableRow>

          </TableHead>
          <TableBody>
            {concluidos.map(projeto => {
              let processoAtual = "Finalizado";
              let dataConclusao = "";
              let dataInicio = null;
              let dataUltimaConclusao = null;

              projeto.grupos?.forEach(grupo => {
                grupo.processos?.forEach(proc => {
                  if (!dataInicio && proc.dataPlanejada) {
                    dataInicio = proc.dataPlanejada;
                  }
                  if (!proc.dataConclusao && processoAtual === "Finalizado") {
                    processoAtual = proc.nome;
                  }
                  if (proc.dataConclusao) {
                    if (!dataUltimaConclusao || proc.dataConclusao > dataUltimaConclusao) {
                      dataUltimaConclusao = proc.dataConclusao;
                    }
                  }
                });
              });

              if (dataUltimaConclusao) {
                dataConclusao = dataUltimaConclusao;
              }

              let menorDataPlanejada = null;
              let maiorDataConclusao = null;

              projeto.grupos?.forEach(grupo => {
                grupo.processos?.forEach(proc => {
                  if (proc.dataPlanejada) {
                    if (!menorDataPlanejada || proc.dataPlanejada < menorDataPlanejada) {
                      menorDataPlanejada = proc.dataPlanejada;
                    }
                  }
                  if (proc.dataConclusao) {
                    if (!maiorDataConclusao || proc.dataConclusao > maiorDataConclusao) {
                      maiorDataConclusao = proc.dataConclusao;
                    }
                  }
                });
              });

              let diasCorridos = "";
              if (menorDataPlanejada) {
                const dtIni = new Date(menorDataPlanejada);
                const dtFim = maiorDataConclusao ? new Date(maiorDataConclusao) : new Date();
                diasCorridos = Math.max(0, Math.ceil((dtFim - dtIni) / (1000 * 60 * 60 * 24)));
              }

              const codigosDoProjeto = (projeto.grupos || []).map(g => ({
                nome: g.nome,
                codigoIM: g.codigoIM,
                codigoCV: g.codigoCV
              }));

              return (
                <TableRow key={projeto.id}>
                  <TableCell>{projeto.cliente}</TableCell>
                  
<TableCell>
  {(() => {
    for (const grupo of projeto.grupos || []) {
      for (const proc of grupo.processos || []) {
        if (proc.op) return proc.op;
      }
    }
    return '-';
  })()}
</TableCell>


<TableCell
  sx={{
    maxWidth: 240,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontWeight: 500
  }}
>
  {projeto.nomeProjeto}
</TableCell>


                  
                  <TableCell>
                    <Button
                      size="small"
                      variant="outlined"
                      onClick={e => handleOpenCodigos(e, codigosDoProjeto)}
                      sx={{ minWidth: 88, fontWeight: 600, borderRadius: 2, border: '1.5px solid #444', color: '#1a237e' }}
                    >
                      {codigosDoProjeto.length} {codigosDoProjeto.length === 1 ? 'ETAPA' : 'ETAPAS'}
                    </Button>
                  </TableCell>
                  <TableCell>{processoAtual}</TableCell>

                  <TableCell>{formatarDataBR(dataConclusao) || "-"}</TableCell>
                  <TableCell>{diasCorridos}</TableCell>
                  
                  <TableCell>
                    <Button
                      size="small"
                      variant="outlined"
                      onClick={() => handleAbrirDetalhesProjeto(projeto)}
                      sx={{ mr: 1 }}
                    >
                      Ver Detalhes
                    </Button>
                    {usuario.tipo === 'admin' && (
                      <IconButton
                        size="small"
                        color="error"
                        onClick={() => handleExcluirProjeto(projeto.id)}
                        title="Excluir Projeto"
                      >
                        <DeleteIcon />
                      </IconButton>
                    )}
                  </TableCell>
                </TableRow>
              );
            })}
            {concluidos.length === 0 && (
              <TableRow>
                <TableCell colSpan={8} align="center">
                  Nenhum projeto concluído.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Collapse>
  </>
)}



      <Popover
        open={Boolean(anchorCodigos)}
        anchorEl={anchorCodigos}
        onClose={handleCloseCodigos}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <div style={{ padding: 16, minWidth: 240 }}>
          <Typography variant="subtitle2" gutterBottom>Códigos dos Grupos:</Typography>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Grupo</TableCell>
                <TableCell>Código IM</TableCell>
                <TableCell>Código CV</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {codigosParaMostrar.length === 0 && (
                <TableRow>
                  <TableCell colSpan={3}>Sem grupos</TableCell>
                </TableRow>
              )}
              {codigosParaMostrar.map((g, idx) => (
                <TableRow key={idx}>
                  <TableCell>{g.nome}</TableCell>
                  <TableCell>{g.codigoIM || '-'}</TableCell>
                  <TableCell>{g.codigoCV || '-'}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </Popover>

      {/* Modal detalhes e edição do projeto */}
      <Dialog
        open={Boolean(selectedProjeto)}
        onClose={handleFecharDetalhesProjeto}
        maxWidth="xl"
        fullWidth
        scroll="paper"
      >
        <DialogTitle>

          {selectedProjeto?.cliente && (
            <span style={{ fontWeight: 600, color: '#1565c0', marginRight: 14 }}>
              {selectedProjeto.cliente}
            </span>
          )}
          Detalhes do Projeto: {selectedProjeto?.nomeProjeto}
        </DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={1}>
            {gruposEdicao.map((grupo, grupoIdx) => (
              <Grid item xs={12} key={grupoIdx}>
                <Paper elevation={2} sx={{ p: 2 }}>
                  <Grid container alignItems="center" spacing={1}>
                    <Grid item xs={12} sm={7} md={4}>
                      <Grid container spacing={2} sx={{ mb: 2 }}>








            <Grid item xs={12} sm={8} md={6} lg={8}>
              <TextField
                label="Nome do Grupo"
                value={grupo.nome}
                onChange={e => handleChangeNomeGrupoEdicao(grupoIdx, e.target.value)}
                fullWidth
                inputProps={{ maxLength: 80 }}
              />
            </Grid>


<Grid item xs={12} sm={4} md={2} lg={4}>
  <TextField
    label="OP"
    value={grupo.processos?.[0]?.op || ''}
    onChange={e => {
      let valor = e.target.value.toUpperCase();
      let novoValor = '';

      if (valor === '') {
        novoValor = '';
      } else if (valor === 'F') {
        novoValor = 'FAA/';
      } else if (valor === 'I') {
        novoValor = 'IMP/';
      } else if (valor.startsWith('FAA/') || valor.startsWith('IMP/')) {
        novoValor = valor.replace(/[^A-Z0-9/]/g, '');
      } else {
        // Bloqueia entradas inválidas fora do padrão
        novoValor = '';
      }

      setGruposEdicao(prev => {
        const novo = [...prev];
        novo[grupoIdx].processos = novo[grupoIdx].processos.map(p => ({
          ...p,
          op: novoValor
        }));
        return novo;
      });
    }}
    fullWidth
    inputProps={{ maxLength: 20 }}
  />
</Grid>


          </Grid>




                    </Grid>


                    
<Grid item xs={12} sm={2} md={2} sx={{ position: 'relative' }}>
  <TextField
    label="Código IM"
    value={grupo.codigoIM || ''}
    onFocus={() => {
      if (!grupo.codigoIM || grupo.codigoIM.length === 0) {
        setDicaCodigoIM('Digite os 4 números iniciais');
      }
    }}
    onChange={e => {
      const valor = e.target.value.toUpperCase().replace(/^IM/, '');
      const numeros = valor.replace(/[^0-9]/g, '').slice(0, 4);
      const letras = valor.replace(/[^A-Z]/g, '').slice(0, 2);
      let dica = '';

      let novoValor = 'IM';
      if (numeros.length > 0) novoValor += numeros;
      if (numeros.length === 4 && letras.length > 0) novoValor += letras;

      if (numeros.length < 4) {
        dica = 'Digite os 4 números iniciais';
      } else if (letras.length < 2) {
        dica = 'Agora digite 2 letras finais';
      } else {
        dica = '';
      }

      handleChangeCodigoIMGrupoEdicao(grupoIdx, novoValor);
      setDicaCodigoIM(dica);
    }}
    sx={{ mb: 0.5, width: '100%' }}
    inputProps={{ maxLength: 10 }}
  />
  {dicaCodigoIM && (
    <div style={{
      position: 'absolute',
      top: '100%',
      left: 0,
      background: '#f2f2f2',
      border: '1px solid #ccc',
      borderRadius: 5,
      padding: '6px 10px',
      fontSize: 13,
      color: '#333',
      marginTop: 4,
      zIndex: 10,
      boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
      whiteSpace: 'nowrap'
    }}>
      💡 {dicaCodigoIM}
    </div>
  )}
</Grid>





<Grid item xs={12} sm={2} md={2} sx={{ position: 'relative' }}>
  <TextField
    label="Código CV"
    value={grupo.codigoCV || ''}
    onFocus={() => {
      if (!grupo.codigoCV || grupo.codigoCV.length === 0) {
        setDicaCodigoCV('Digite os 4 primeiros números da FACA');
      }
    }}
    onChange={e => {
      const valorDigitado = e.target.value.toUpperCase().replace(/^CV/i, '');

      const numeros = valorDigitado.replace(/\D/g, '').slice(0, 4);
      const resto = valorDigitado.slice(numeros.length);
      const letras = resto.replace(/[^A-Z]/g, '').slice(0, 3);
      const numerosFinais = resto.slice(letras.length).replace(/\D/g, '').slice(0, 3);

      let novoCV = `CV${numeros}`;
      if (letras.length > 0 || numerosFinais.length > 0) {
        novoCV += `.${letras}${numerosFinais}`;
      }

      let dica = '';
      if (numeros.length < 4) {
        dica = 'Digite os 4 primeiros números da FACA';
      } else if (letras.length < 1) {
        dica = 'Agora digite as 3 letras do cliente';
      } else if (letras.length < 3) {
        dica = 'Continue digitando as 3 letras do cliente';
      } else if (numerosFinais.length < 3) {
        dica = 'Agora digite os 3 números da revisão da faca';
      }

      handleChangeCodigoCVGrupoEdicao(grupoIdx, novoCV);
      setDicaCodigoCV(dica);
    }}
    fullWidth
    inputProps={{ maxLength: 20 }}
    InputLabelProps={{ shrink: true }} // Isso garante que a label não ocupe espaço variável
  />
  {dicaCodigoCV && (
    <div style={{
      position: 'absolute',
      top: '45px',
      left: 0,
      background: '#f2f2f2',
      border: '1px solid #ccc',
      borderRadius: 5,
      padding: '6px 10px',
      fontSize: 13,
      color: '#333',
      zIndex: 10,
      boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
      whiteSpace: 'nowrap'
    }}>
      💡 {dicaCodigoCV}
    </div>
  )}
</Grid>






                    <Grid item xs={12} sm={2} md={2}>
                  
                    {/* Botão Anexos */}
                    <Button
                    variant="contained"
                    color="secondary"
                    onClick={() => {
                      setGrupoAnexosIdx(null); // Zera primeiro
                      setTimeout(() => {
                        setGrupoAnexosIdx(grupoIdx); // Só depois define
                        setOpenModalAnexos(true);
                      }, 0);
                    }}
                    fullWidth
                    sx={{ ml: 1 }}
                  >
                    Anexos
                  </Button>



                  </Grid>


                  {(tiposDoUsuario.some(t => ['admin', 'projetos', 'qualidade'].includes(t))) && (                  <Grid item>
                   
                   
                    <IconButton
                    color="primary"
                    onClick={() => {
                      setGrupoSelecionadoParaProcessos(grupoIdx);
                      setProcessosSelecionadosParaAdicionar([]);
                    }}
                    title="Adicionar Processos"
                  >
                    <AddIcon />
                  </IconButton>


<IconButton
  color="secondary"
  onClick={() => handleDuplicarGrupoEdicao(grupoIdx)}
  title="Duplicar Grupo"
>
  <ContentCopyIcon />
</IconButton>



                    <IconButton color="error" onClick={() => handleRemoverGrupoNaEdicao(grupoIdx)}>
                      <DeleteIcon />
                    </IconButton>
                  </Grid>
                )}

                  </Grid>
                  <div style={{ overflowX: 'auto', maxWidth: '100vw' }}>
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell>Processo</TableCell>
                          <TableCell>Status</TableCell>
                          <TableCell>Data Planejada</TableCell>
                          <TableCell>Data Chegada Insumo</TableCell>
                          <TableCell>Data Renegociada</TableCell>
                          <TableCell>Data Conclusão</TableCell>
                          <TableCell>Insumo</TableCell>
                          <TableCell>Disponibilidade</TableCell>
                          </TableRow>
                      </TableHead>
                      <DragDropContext onDragEnd={result => handleDragEndProcessoGrupo(result, grupoIdx)}>
  <Droppable droppableId={`grupo-${grupoIdx}`}>
    {provided => (
      <TableBody ref={provided.innerRef} {...provided.droppableProps}>
        {grupo.processos.map((proc, procIdx) => {
          const rowStyle = getRowStyle(grupo, procIdx, proc.status);
          const rowKey = proc.nome + '-' + procIdx;
          return (
            <Draggable key={rowKey} draggableId={rowKey} index={procIdx}>
              {providedDraggable => (
                <TableRow
                  ref={providedDraggable.innerRef}
                  {...providedDraggable.draggableProps}
                  {...providedDraggable.dragHandleProps}
                  style={{
                    ...rowStyle,
                    ...providedDraggable.draggableProps.style,
                    cursor: 'grab'
                  }}
                >
<TableCell>
  {proc.nome === '' ? (
    <FormControl size="small" fullWidth>
      <Select
        value={processoEdicao.nome}
        onChange={(e) => {
          const novoNome = e.target.value;
          setProcessoEdicao(prev => ({ ...prev, nome: novoNome }));
          handleChangeProcessoGrupoEdicao(grupoIdx, procIdx, 'nome', novoNome);
        }}
      >
        {nomesProcessos
          .filter(procNome => !grupo.processos.some(p => p.nome === procNome))
          .map(procNome => (
            <MenuItem key={procNome} value={procNome}>
              {procNome}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  ) : (
    proc.nome
  )}
</TableCell>

                  <TableCell>
                    <FormControl size="small" fullWidth>
                      <Select
                        value={proc.status}
                        onChange={e => handleChangeProcessoGrupoEdicao(grupoIdx, procIdx, 'status', e.target.value)}
                      >
                        <MenuItem value="">Selecione</MenuItem>
                        <MenuItem value="Planejado">Planejado</MenuItem>
                        <MenuItem value="Em curso">Em curso</MenuItem>
                        <MenuItem value="Pendente">Pendente</MenuItem>
                        <MenuItem value="Concluído">Concluído</MenuItem>
                      </Select>
                    </FormControl>
                  </TableCell>
                  <TableCell>
                    <TextField
                      type="date"
                      size="small"
                      value={proc.dataPlanejada}
                      onChange={e => handleChangeProcessoGrupoEdicao(grupoIdx, procIdx, 'dataPlanejada', e.target.value)}
                      InputLabelProps={{ shrink: true }}
                      inputProps={{ placeholder: "dd/mm/yyyy" }}
                    />
                  </TableCell>
                  <TableCell>
                    <TextField
                      type="date"
                      size="small"
                      value={proc.dataChegadaInsumo}
                      onChange={e => handleChangeProcessoGrupoEdicao(grupoIdx, procIdx, 'dataChegadaInsumo', e.target.value)}
                      InputLabelProps={{ shrink: true }}
                    />
                  </TableCell>
                  <TableCell>
                    <TextField
                      type="date"
                      size="small"
                      value={proc.dataRenegociada}
                      onChange={e => handleChangeProcessoGrupoEdicao(grupoIdx, procIdx, 'dataRenegociada', e.target.value)}
                      InputLabelProps={{ shrink: true }}
                    />
                  </TableCell>
                  <TableCell>
                    <TextField
                      type="date"
                      size="small"
                      value={proc.dataConclusao}
                      onChange={e => handleChangeProcessoGrupoEdicao(grupoIdx, procIdx, 'dataConclusao', e.target.value)}
                      InputLabelProps={{ shrink: true }}
                    />
                  </TableCell>
                  <TableCell>
                    <TextField
                      size="small"
                      value={proc.insumo}
                      onChange={e => handleChangeProcessoGrupoEdicao(grupoIdx, procIdx, 'insumo', e.target.value)}
                      placeholder={insumosMap[proc.nome] || ''}
                      sx={{ minWidth: 120, maxWidth: 220 }}
                    />
                  </TableCell>
                  <TableCell>
                    <FormControl size="small" fullWidth>
                      <Select
                        value={proc.disponibilidade}
                        onChange={e => handleChangeProcessoGrupoEdicao(grupoIdx, procIdx, 'disponibilidade', e.target.value)}
                      >
                        <MenuItem value="">Selecione</MenuItem>
                        <MenuItem value="Disponível">Disponível</MenuItem>
                        <MenuItem value="Indisponível">Indisponível</MenuItem>
                      </Select>
                    </FormControl>
                  </TableCell>

                  <TableCell>
                    <TextField
                      size="small"
                      value={proc.op || ''}
                      onChange={e => handleChangeProcessoGrupoEdicao(grupoIdx, procIdx, 'op', e.target.value)}
                      inputProps={{ maxLength: 20 }}
                    />
                  </TableCell>

                  {(tiposDoUsuario.some(t => ['admin', 'projetos', 'qualidade'].includes(t))) && (                  <TableCell>
                    <IconButton
                      color="error"
                      size="small"
                      title="Remover Processo"
                      onClick={() => {
                        setGruposEdicao(prev => {
                          const novaLista = [...prev];
                          novaLista[grupoIdx].processos = novaLista[grupoIdx].processos.filter((_, i) => i !== procIdx);
                          return novaLista;
                        });
                      }}
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>

                    <IconButton
                      color="primary"
                      size="small"
                      title="Adicionar Processo Após"
                      disabled={
                        grupo.processos[procIdx + 1] && grupo.processos[procIdx + 1].nome === ''
                      }
                      onClick={() => {
                        setGruposEdicao(prev => {
                          const novaLista = [...prev];
                          if (!(novaLista[grupoIdx].processos[procIdx + 1] && novaLista[grupoIdx].processos[procIdx + 1].nome === '')) {
                            novaLista[grupoIdx].processos = [
                              ...novaLista[grupoIdx].processos.slice(0, procIdx + 1),
                              {
                                nome: '', status: '', dataPlanejada: '', dataChegadaInsumo: '',
                                dataRenegociada: '', dataConclusao: '', insumo: '', disponibilidade: '', comentarios: ''
                              },
                              ...novaLista[grupoIdx].processos.slice(procIdx + 1)
                            ];
                          }
                          return novaLista;
                        });
                        setProcessoEdicao({ grupoIdx, procIdx: procIdx + 1, nome: '' });
                      }}
                    >
                      <AddIcon fontSize="small" />
                    </IconButton>
                  </TableCell>
                )}

                </TableRow>
              )}
            </Draggable>
          );
        })}
        {provided.placeholder}
      </TableBody>
    )}
  </Droppable>
</DragDropContext>
                    </Table>
                  </div>
                </Paper>
              </Grid>
            ))}
            
            {(tiposDoUsuario.some(t => ['admin', 'projetos', 'qualidade'].includes(t))) && (            <Grid item xs={12}>
              <Paper elevation={0} sx={{ p: 2, background: '#f9f9f9', border: '1px dashed #ccc' }}>
                <Typography variant="subtitle2" gutterBottom>Adicionar Novo Grupo</Typography>
                <Grid container spacing={1} alignItems="center">
                  <Grid item xs={12} sm={7} md={4}>
                    <TextField
                      label="Nome do Grupo"
                      value={novoGrupoNomeEdicao}
                      onChange={e => setNovoGrupoNomeEdicao(e.target.value)}
                      fullWidth
                      inputProps={{ maxLength: 80 }}
                      sx={{ maxWidth: 520, minWidth: 320 }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={5} md={3}>
                    <FormControl fullWidth sx={{ minWidth: 180, maxWidth: 260 }}>
                      <InputLabel>Processos do Grupo</InputLabel>
                      <Select
                        multiple
                        value={processosSelecionadosEdicao}
                        onChange={e => setProcessosSelecionadosEdicao(e.target.value)}
                        renderValue={selected => selected.join(', ')}
                        sx={{ minWidth: 160 }}
                        MenuProps={{ PaperProps: { sx: { minWidth: 200 } } }}
                      >
                        {nomesProcessos.map(proc => (
                          <MenuItem key={proc} value={proc}>
                          <Checkbox
                            checked={processosSelecionadosEdicao.includes(proc)}
                            disableRipple
                            size="small"
                            sx={{ p: 0, pr: 1 }}
                          />

                            {proc}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={12} md={1}>
                    <Button
                      variant="outlined"
                      startIcon={<AddIcon />}
                      onClick={handleAdicionarGrupoNaEdicao}
                      sx={{ minWidth: 140, mt: { xs: 1, md: 0 } }}
                    >
                      Adicionar Grupo
                    </Button>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          )}

          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleFecharDetalhesProjeto}>Fechar</Button>
          <Button
            onClick={handleExportarPDFProjeto}
            variant="contained"
            color="success"
            sx={{ fontWeight: 600 }}
          >
            Exportar PDF
          </Button>
          <Button onClick={handleSalvarEdicaoProjeto} variant="contained" color="primary">
            Salvar Alterações
          </Button>
        </DialogActions>



        <Dialog
  open={openModalAnexos}
  onClose={() => setOpenModalAnexos(false)}
  maxWidth="md"
  fullWidth
>
  <DialogTitle>Anexos do Grupo</DialogTitle>
  <DialogContent dividers>
    <Grid container spacing={2} sx={{ mb: 3 }}>

    {uploading && (
  <Typography variant="subtitle2" color="primary" sx={{ mt: 2 }}>
    Enviando arquivo...
  </Typography>
)}

</Grid>

{/* Fazer Upload dos Anexos */}
{(tiposDoUsuario.some(t => ['admin', 'projetos', 'qualidade'].includes(t))) && (  <>
    <Typography
      align="center"
      sx={{ fontWeight: 'bold', fontSize: '22px', mb: 0 }}
    >
      Anexe seus arquivos aqui:
    </Typography>

    <Grid container spacing={2} justifyContent="center" sx={{ mt: 1 }}>
      <Grid item xs={12} sm={6} md={4}>
        <Button variant="outlined" startIcon={<PictureAsPdfIcon />} component="label" fullWidth>
          Desenho Técnico
          <input
            type="file"
            hidden
            accept="application/pdf"
            onChange={(e) => handleUploadDesenhoTecnico(e, grupoAnexosIdx)}
          />
        </Button>
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <Button variant="outlined" startIcon={<PictureAsPdfIcon />} component="label" fullWidth>
          Desenho Individual
          <input
            type="file"
            hidden
            accept="application/pdf"
            onChange={(e) => handleUploadDesenhoIndividual(e, grupoAnexosIdx)}
          />
        </Button>
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <Button variant="outlined" startIcon={<ImageIcon />} component="label" fullWidth>
          Anexo 1
          <input
            type="file"
            hidden
            accept="image/jpeg"
            onChange={(e) => handleUploadAnexo1(e, grupoAnexosIdx)}
          />
        </Button>
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <Button variant="outlined" startIcon={<ImageIcon />} component="label" fullWidth>
          Anexo 2
          <input
            type="file"
            hidden
            accept="image/jpeg"
            onChange={(e) => handleUploadAnexo2(e, grupoAnexosIdx)}
          />
        </Button>
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <Button variant="outlined" startIcon={<ImageIcon />} component="label" fullWidth>
          Anexo 3
          <input
            type="file"
            hidden
            accept="image/jpeg"
            onChange={(e) => handleUploadAnexo3(e, grupoAnexosIdx)}
          />
        </Button>
      </Grid>
    </Grid>
  </>
)}



<Typography
  variant="h6"
  gutterBottom
  align="center"
  sx={{ fontWeight: 'bold', mt: 4 }}
>
  Anexos Disponíveis
</Typography>




{typeof grupoAnexosIdx === 'number' &&
  grupoAnexosIdx >= 0 &&
  grupoAnexosIdx < gruposEdicao.length &&
  gruposEdicao[grupoAnexosIdx]?.arquivosAnexados && (

  <Grid container spacing={2} justifyContent="center">
    
    {typeof grupoAnexosIdx === 'number' && gruposEdicao[grupoAnexosIdx]?.arquivosAnexados && (
  <Grid container spacing={2} justifyContent="center">
    {gruposEdicao[grupoAnexosIdx].arquivosAnexados.desenhoTecnico && (
      <Grid item xs={12} sm={6} md={4}>
        <Paper elevation={2} sx={{ p: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <PictureAsPdfIcon sx={{ color: '#1565c0', mr: 1 }} />
            <a
              href={`https://projetos.impram.com.br/uploads/desenho_tecnico/${gruposEdicao[grupoAnexosIdx].arquivosAnexados.desenhoTecnico}`}
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: 'none', color: '#1565c0', fontWeight: 600 }}
            >
              Desenho Técnico
            </a>
          </div>
          {(tiposDoUsuario.some(t => ['admin', 'projetos', 'qualidade'].includes(t))) && (          <Button
            size="small"
            color="error"
            onClick={() => handleDeletarAnexo('desenho_tecnico', gruposEdicao[grupoAnexosIdx].arquivosAnexados.desenhoTecnico, grupoAnexosIdx)}
            sx={{ ml: 2 }}
          >
            Excluir
          </Button>
        )}

        </Paper>
      </Grid>
    )}

    {gruposEdicao[grupoAnexosIdx].arquivosAnexados.desenhoIndividual && (
      <Grid item xs={12} sm={6} md={4}>
        <Paper elevation={2} sx={{ p: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <PictureAsPdfIcon sx={{ color: '#1565c0', mr: 1 }} />
            <a
              href={`https://projetos.impram.com.br/uploads/desenho_individual/${gruposEdicao[grupoAnexosIdx].arquivosAnexados.desenhoIndividual}`}
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: 'none', color: '#1565c0', fontWeight: 600 }}
            >
              Desenho Individual
            </a>
          </div>
          <Button
            size="small"
            color="error"
            onClick={() => handleDeletarAnexo('desenho_individual', gruposEdicao[grupoAnexosIdx].arquivosAnexados.desenhoIndividual, grupoAnexosIdx)}
            sx={{ ml: 2 }}
          >
            Excluir
          </Button>
        </Paper>
      </Grid>
    )}

    {gruposEdicao[grupoAnexosIdx].arquivosAnexados.anexo1 && (
      <Grid item xs={12} sm={6} md={4}>
        <Paper elevation={2} sx={{ p: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <ImageIcon sx={{ color: '#1565c0', mr: 1 }} />
            <a
              href={`https://projetos.impram.com.br/uploads/anexos/${gruposEdicao[grupoAnexosIdx].arquivosAnexados.anexo1}`}
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: 'none', color: '#1565c0', fontWeight: 600 }}
            >
              Anexo 1
            </a>
          </div>
          <Button
          size="small"
          color="error"
          onClick={() => handleDeletarAnexo('anexos', gruposEdicao[grupoAnexosIdx].arquivosAnexados.anexo1, grupoAnexosIdx)}
          sx={{ ml: 2 }}
        >
          Excluir
        </Button>

        </Paper>
      </Grid>
    )}

    {gruposEdicao[grupoAnexosIdx].arquivosAnexados.anexo2 && (
      <Grid item xs={12} sm={6} md={4}>
        <Paper elevation={2} sx={{ p: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <ImageIcon sx={{ color: '#1565c0', mr: 1 }} />
            <a
              href={`https://projetos.impram.com.br/uploads/anexos/${gruposEdicao[grupoAnexosIdx].arquivosAnexados.anexo2}`}
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: 'none', color: '#1565c0', fontWeight: 600 }}
            >
              Anexo 2
            </a>
          </div>
          <Button
          size="small"
          color="error"
          onClick={() => handleDeletarAnexo('anexos', gruposEdicao[grupoAnexosIdx].arquivosAnexados.anexo2, grupoAnexosIdx)}
          sx={{ ml: 2 }}
        >
          Excluir
        </Button>

        </Paper>
      </Grid>
    )}

    {gruposEdicao[grupoAnexosIdx].arquivosAnexados.anexo3 && (
      <Grid item xs={12} sm={6} md={4}>
        <Paper elevation={2} sx={{ p: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <ImageIcon sx={{ color: '#1565c0', mr: 1 }} />
            <a
              href={`https://projetos.impram.com.br/uploads/anexos/${gruposEdicao[grupoAnexosIdx].arquivosAnexados.anexo3}`}
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: 'none', color: '#1565c0', fontWeight: 600 }}
            >
              Anexo 3
            </a>
          </div>
          <Button
          size="small"
          color="error"
          onClick={() => handleDeletarAnexo('anexos', gruposEdicao[grupoAnexosIdx].arquivosAnexados.anexo3, grupoAnexosIdx)}
          sx={{ ml: 2 }}
        >
          Excluir
        </Button>

        </Paper>
      </Grid>
    )}
  </Grid>
)}


  </Grid>
)}




















</DialogContent>

{(tiposDoUsuario.some(t => ['admin', 'projetos', 'qualidade'].includes(t))) && (  <>
<DialogActions>
  <Button
    color="error"
    onClick={() => handleExcluirTodosAnexosDoGrupo(grupoAnexosIdx)}
  >
    Excluir Todos
  </Button>
  <Button onClick={() => setOpenModalAnexos(false)}>Fechar</Button>
</DialogActions>
</>
)}



</Dialog>







      </Dialog>

      
      <Dialog open={grupoSelecionadoParaProcessos !== null} onClose={() => setGrupoSelecionadoParaProcessos(null)}>
  <DialogTitle>Selecionar Processos para Adicionar</DialogTitle>
  <DialogContent dividers>
    <FormControl fullWidth>
      <InputLabel>Processos</InputLabel>
      <Select
        multiple
        value={processosSelecionadosParaAdicionar}
        onChange={(e) => setProcessosSelecionadosParaAdicionar(e.target.value)}
        renderValue={(selected) => selected.join(', ')}
        sx={{ minWidth: 300 }}
        MenuProps={{ PaperProps: { style: { maxHeight: 300 } } }}
      >
        {nomesProcessos.map((proc) => (
          <MenuItem key={proc} value={proc}>
          <Checkbox
            checked={processosSelecionadosParaAdicionar.includes(proc)}
            disableRipple
            size="small"
            sx={{ p: 0, pr: 1 }}
          />

            {proc}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setGrupoSelecionadoParaProcessos(null)}>Cancelar</Button>
    <Button
      onClick={() => {
        processosSelecionadosParaAdicionar.forEach(proc =>
          handleAdicionarProcessoEdicao(grupoSelecionadoParaProcessos, proc)
        );
        setGrupoSelecionadoParaProcessos(null);
        setProcessosSelecionadosParaAdicionar([]);
      }}
      variant="contained"
      color="primary"
    >
      Adicionar Processos
    </Button>
  </DialogActions>
</Dialog>

      

    </Container>
  );
}


export default App;
